﻿/* Tuokus live rebuild marker 2026-06-21 01:18 HKT */
/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function() {
  if (window.__TUOKUS_FINAL_RECOVERY_ACTIVE) {
    return;
  }

  var SWATCH_TRACK_SELECTOR = '.color-swatch-list--large, .block-swatch-list, .variant-swatch-list';
  var GALLERY_TRACK_SELECTOR = '.product-gallery__thumbnail-list';
  var GENERIC_RAIL_SELECTOR = '.tuokus-promo-module__rail, .tuokus-collection-discovery__rail, .activity-product-list, .product-list--scrollable, .template-index [id$="__homepage_featured_collections"] [data-section-type="activity-featured-collections"] .activity-collection-grid';
  var GENERIC_RAIL_TRACK_SELECTOR = '[data-tuokus-drag-track="generic"]';
  var SWATCH_INTERACTIVE_SELECTOR = '.variant-swatch__item, .block-swatch__item, .color-swatch__item';
  var DRAG_THRESHOLD_MOUSE = 5;
  var DRAG_THRESHOLD_TOUCH = 8;
  var DRAG_SUPPRESS_MS = 220;
  var optionRootFrames = new WeakMap();
  var optionRealignFrames = Object.create(null);
  var optionRealignTimers = Object.create(null);
  var pickerRealignFrames = Object.create(null);
  var galleryRealignFrames = Object.create(null);
  var optionScrollMemory = Object.create(null);
  var lastOptionByForm = Object.create(null);
  var forcedVariantSyncTimers = Object.create(null);
  var dragState = null;
  var genericRailDragState = null;
  var genericRailInitFrame = 0;
  var genericRailObserver = null;

  function formUsesProductRerender(formId) {
    if (!formId) {
      return false;
    }

    return Boolean(document.querySelector('product-rerender[observe-form="' + formId + '"]'));
  }

  function getOptionKey(formId, optionPosition) {
    if (!formId || !optionPosition) {
      return null;
    }

    return formId + '::' + optionPosition;
  }

  function getOptionTrack(optionRoot) {
    if (!optionRoot || !optionRoot.querySelector) {
      return null;
    }

    return optionRoot.querySelector(SWATCH_TRACK_SELECTOR);
  }

  function getControlForm(control) {
    if (!control) {
      return null;
    }

    return control.form || getFormById(control.getAttribute('form'));
  }

  function getFormById(formId) {
    if (!formId) {
      return null;
    }

    return document.getElementById(formId) || document.forms.namedItem(formId) || null;
  }

  function getVariantControlFromTarget(target) {
    if (!target || !target.closest) {
      return null;
    }

    if (target.matches && target.matches('.product-form__single-selector[data-option-position]')) {
      return target;
    }

    var label = target.closest('.variant-swatch__item[for], .block-swatch__item[for], .color-swatch__item[for], label[for]');

    if (!label) {
      return null;
    }

    return label.control || document.getElementById(label.getAttribute('for'));
  }

  function getPickerForFormId(formId) {
    if (!formId) {
      return null;
    }

    return document.querySelector('variant-picker[form-id="' + formId + '"]');
  }

  function getOptionValuesForForm(form) {
    if (!form) {
      return [];
    }

    return Array.from(form.elements)
      .filter(function(item) {
        return item.matches(
          'input[data-option-position]:checked, ' +
          'input[data-option-position][type="hidden"], ' +
          'select[data-option-position]'
        );
      })
      .sort(function(a, b) {
        return parseInt(a.getAttribute('data-option-position'), 10) - parseInt(b.getAttribute('data-option-position'), 10);
      })
      .map(function(input) {
        return input.value;
      });
  }

  function normalizeProductOptionToken(value) {
    return String(value || '')
      .replace(/^[\s\u3000]+|[\s\u3000]+$/g, '')
      .replace(/\s+/g, ' ')
      .split(':')[0]
      .trim()
      .toLowerCase();
  }

  function normalizeProductOptionName(value) {
    var token = normalizeProductOptionToken(value);

    if ([
      'color',
      'colour',
      'couleur',
      'cor',
      'colore',
      'farbe',
      '\u8272',
      '\u30ab\u30e9\u30fc'
    ].indexOf(token) !== -1) {
      return 'color';
    }

    if (['size', '\u30b5\u30a4\u30ba'].indexOf(token) !== -1) {
      return 'size';
    }

    if ([
      'pattern',
      'design',
      'style',
      '\u67c4',
      '\u30c7\u30b6\u30a4\u30f3',
      '\u30b9\u30bf\u30a4\u30eb'
    ].indexOf(token) !== -1) {
      return 'pattern';
    }

    return token;
  }

  function getControlDisplayValue(control) {
    var label = null;
    var selectedOption = null;
    var rawValue = '';
    var controlId = '';

    if (!control) {
      return '';
    }

    if (control.matches && control.matches('select')) {
      selectedOption = control.options && control.selectedIndex >= 0 ? control.options[control.selectedIndex] : null;
      rawValue = selectedOption ? (selectedOption.getAttribute('data-raw-value') || selectedOption.text || selectedOption.value) : control.value;

      return String(rawValue || '').trim();
    }

    controlId = String(control.id || '');

    if (controlId) {
      label = document.querySelector('label[for="' + controlId.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"]');
    }

    if (!label && control.closest) {
      label = control.closest('label');
    }

    if (label) {
      rawValue = label.getAttribute('data-raw-value') || label.getAttribute('data-display-value') || label.getAttribute('title') || label.textContent;
    }

    if (!rawValue) {
      rawValue = control.value;
    }

    return String(rawValue || '').trim();
  }

  function getCurrentOptionValueMap(sectionRoot) {
    var form = null;
    var optionNameByPosition = Object.create(null);
    var valueMap = Object.create(null);

    if (!sectionRoot || !sectionRoot.querySelectorAll) {
      return valueMap;
    }

    form = sectionRoot.querySelector('form[action*="/cart/add"], form[id^="product-form"]');

    if (!form) {
      return valueMap;
    }

    sectionRoot.querySelectorAll('.product-form__option').forEach(function(optionRoot) {
      var control = optionRoot.querySelector('[data-option-position]');
      var label = optionRoot.querySelector('.product-form__option-name');
      var position = control ? String(control.getAttribute('data-option-position') || '') : '';
      var optionName = normalizeProductOptionName(label ? label.textContent : (control ? control.getAttribute('name') : ''));

      if (!position) {
        return;
      }

      optionNameByPosition[position] = optionName || ('option' + position);
    });

    Array.from(form.elements)
      .filter(function(item) {
        return item.matches(
          'input[data-option-position]:checked, ' +
          'input[data-option-position][type="hidden"], ' +
          'select[data-option-position]'
        );
      })
      .sort(function(a, b) {
        return parseInt(a.getAttribute('data-option-position'), 10) - parseInt(b.getAttribute('data-option-position'), 10);
      })
      .forEach(function(control) {
        var position = String(control.getAttribute('data-option-position') || '');
        var optionName = optionNameByPosition[position] || ('option' + position);
        var optionValue = normalizeProductOptionToken(getControlDisplayValue(control));

        if (!position || !optionValue) {
          return;
        }

        valueMap[optionName] = optionValue;
        valueMap['option' + position] = optionValue;
      });

    return valueMap;
  }

  function matchesVariantIdsCsv(variantIdsCsv, variantId) {
    var currentVariantId = variantId ? String(variantId) : '';
    var value = String(variantIdsCsv || '').trim();

    if (!currentVariantId || !value) {
      return false;
    }

    return (',' + value + ',').indexOf(',' + currentVariantId + ',') !== -1;
  }

  function getGalleryItemGroupKey(item) {
    var groupName = normalizeProductOptionName(item.getAttribute('data-group-name'));
    var groupValue = normalizeProductOptionToken(item.getAttribute('data-group-value'));
    var variantIdsCsv = String(item.getAttribute('data-variant-ids') || '').trim();

    if (groupName && groupValue) {
      return 'group:' + groupName + '::' + groupValue;
    }

    if (variantIdsCsv) {
      return 'variant:' + variantIdsCsv;
    }

    return '';
  }

  function getGalleryItemGroupMatch(item, optionValueMap) {
    var groupName = normalizeProductOptionName(item.getAttribute('data-group-name'));
    var groupValue = normalizeProductOptionToken(item.getAttribute('data-group-value'));
    var currentOptionValue = '';

    if (!groupName || !groupValue) {
      return null;
    }

    currentOptionValue = optionValueMap && optionValueMap[groupName] ? optionValueMap[groupName] : '';

    if (!currentOptionValue) {
      return null;
    }

    return currentOptionValue === groupValue;
  }

  function getPreferredVisibleGalleryItem(sectionRoot, visibleCarouselItems, currentVariantId, currentOptionValueMap) {
    var variantId = currentVariantId ? String(currentVariantId) : '';
    var selectedVisibleItem = null;
    var exactVariantItem = null;
    var groupedItem = null;

    if (!sectionRoot || !visibleCarouselItems || !visibleCarouselItems.length) {
      return null;
    }

    selectedVisibleItem = sectionRoot.querySelector('.product-gallery__carousel-item.is-selected:not(.is-filtered)');

    visibleCarouselItems.some(function(item) {
      if (variantId && matchesVariantIdsCsv(item.getAttribute('data-variant-ids'), variantId)) {
        exactVariantItem = item;
        return true;
      }

      return false;
    });

    visibleCarouselItems.some(function(item) {
      if (getGalleryItemGroupMatch(item, currentOptionValueMap) === true) {
        groupedItem = item;
        return true;
      }

      return false;
    });

    if (selectedVisibleItem) {
      if (!variantId) {
        return selectedVisibleItem;
      }

      if (matchesVariantIdsCsv(selectedVisibleItem.getAttribute('data-variant-ids'), variantId)) {
        return selectedVisibleItem;
      }

      if (getGalleryItemGroupMatch(selectedVisibleItem, currentOptionValueMap) === true) {
        return selectedVisibleItem;
      }
    }

    return exactVariantItem || groupedItem || selectedVisibleItem || visibleCarouselItems[0] || null;
  }

  function restoreVariantPrimaryGalleryMedia(sectionRoot, currentVariantId, currentOptionValueMap) {
    var variantId = currentVariantId ? String(currentVariantId) : '';
    var preferredItem = null;
    var mediaId = '';
    var thumbnail = null;

    if (!sectionRoot || !sectionRoot.querySelectorAll) {
      return null;
    }

    preferredItem = Array.prototype.slice.call(sectionRoot.querySelectorAll('.product-gallery__carousel-item')).find(function(item) {
      if (variantId && matchesVariantIdsCsv(item.getAttribute('data-variant-ids'), variantId)) {
        return true;
      }

      return getGalleryItemGroupMatch(item, currentOptionValueMap) === true;
    }) || sectionRoot.querySelector('.product-gallery__carousel-item.is-selected') || sectionRoot.querySelector('.product-gallery__carousel-item');

    if (!preferredItem) {
      return null;
    }

    preferredItem.classList.remove('is-filtered');
    mediaId = preferredItem.getAttribute('data-media-id') || '';
    thumbnail = mediaId ? sectionRoot.querySelector('.product-gallery__thumbnail[data-media-id="' + mediaId + '"]') : null;

    if (thumbnail) {
      thumbnail.classList.remove('is-filtered');
    }

    return preferredItem;
  }

  function scheduleForcedVariantSync(control) {
    if (!control || !control.matches || !control.matches('.product-form__single-selector[data-option-position]')) {
      return;
    }

    var form = getControlForm(control);

    if (!form || !form.id) {
      return;
    }

    var formId = form.id;
    var picker = getPickerForFormId(formId);
    var variantIdInput = form.querySelector('[name="id"]');

    if (!picker || !variantIdInput || typeof picker.selectCombination !== 'function') {
      return;
    }

    window.clearTimeout(forcedVariantSyncTimers[formId]);

    var beforeVariantId = variantIdInput.value;
    var optionValues = getOptionValuesForForm(form);

    forcedVariantSyncTimers[formId] = window.setTimeout(function() {
      var afterVariantId = variantIdInput.value;

      if (!control.checked || beforeVariantId !== afterVariantId) {
        return;
      }

      picker.selectCombination({
        optionValues: optionValues,
        productChange: control.hasAttribute('data-product-url')
      });
    }, 160);
  }

  function rememberOptionScroll(formId, optionPosition, optionRoot) {
    var key = getOptionKey(formId, optionPosition);
    var track = getOptionTrack(optionRoot);

    if (!key || !track) {
      return;
    }

    optionScrollMemory[key] = track.scrollLeft;
    lastOptionByForm[formId] = optionPosition;
  }

  function rememberOptionScrollFromTarget(target) {
    var optionInput = getVariantControlFromTarget(target);
    var formId = null;
    var optionPosition = null;
    var optionRoot = null;

    if (!optionInput || !optionInput.matches || !optionInput.matches('.product-form__single-selector[data-option-position]')) {
      return;
    }

    optionRoot = optionInput.closest('.product-form__option');
    formId = optionInput.getAttribute('form') || (optionInput.form ? optionInput.form.id : null);
    optionPosition = optionInput.getAttribute('data-option-position');

    if (!formId || !optionPosition || !optionRoot) {
      return;
    }

    rememberOptionScroll(formId, optionPosition, optionRoot);
  }

  function restoreOptionScroll(formId, optionPosition, optionRoot) {
    var key = getOptionKey(formId, optionPosition);
    var track = getOptionTrack(optionRoot);
    var rememberedScrollLeft = key ? optionScrollMemory[key] : null;

    if (!track || typeof rememberedScrollLeft !== 'number') {
      return;
    }

    track.scrollLeft = rememberedScrollLeft;
  }

  function clearFrameBucket(frameBucket, key) {
    var frameIds = frameBucket[key];

    if (!frameIds) {
      return;
    }

    frameIds.forEach(window.cancelAnimationFrame);
    delete frameBucket[key];
  }

  function clearTimerBucket(timerBucket, key) {
    var timerIds = timerBucket[key];

    if (!timerIds) {
      return;
    }

    timerIds.forEach(window.clearTimeout);
    delete timerBucket[key];
  }

  function setTrackScroll(track, nextScrollLeft, behavior) {
    if (!track) {
      return;
    }

    var maxScrollLeft = Math.max(track.scrollWidth - track.clientWidth, 0);
    var clampedScrollLeft = Math.max(0, Math.min(nextScrollLeft, maxScrollLeft));

    if (Math.abs(clampedScrollLeft - track.scrollLeft) < 1) {
      return;
    }

    if (behavior === 'smooth' && typeof track.scrollTo === 'function') {
      track.scrollTo({
        left: clampedScrollLeft,
        behavior: 'smooth'
      });
    } else {
      track.scrollLeft = clampedScrollLeft;
    }
  }

  function persistTrackScroll(track) {
    if (!track || !track.closest) {
      return;
    }

    var optionRoot = track.closest('.product-form__option');
    var optionInput = optionRoot ? optionRoot.querySelector('[data-option-position]') : null;
    var formId = optionInput ? optionInput.getAttribute('form') || (optionInput.form ? optionInput.form.id : null) : null;
    var optionPosition = optionInput ? optionInput.getAttribute('data-option-position') : null;
    var key = getOptionKey(formId, optionPosition);

    if (!key) {
      return;
    }

    optionScrollMemory[key] = track.scrollLeft;
  }

  function trackPrefersCentering(track) {
    return Boolean(track && track.matches && track.matches(GALLERY_TRACK_SELECTOR));
  }

  function getTrackVisiblePadding(track) {
    if (!track) {
      return 0;
    }

    return track.matches && track.matches(GALLERY_TRACK_SELECTOR) ? 14 : Math.min(24, Math.max(12, track.clientWidth * 0.08));
  }

  function scrollTrackElementIntoView(track, element, behavior) {
    if (!track || !element) {
      return;
    }

    window.requestAnimationFrame(function() {
      var trackWidth = track.clientWidth;
      var maxScrollLeft = Math.max(track.scrollWidth - trackWidth, 0);

      if (!trackWidth || maxScrollLeft <= 0) {
        return;
      }

      var elementStyle = window.getComputedStyle(element);
      var elementStart = element.offsetLeft - (parseFloat(elementStyle.marginLeft) || 0);
      var elementEnd = element.offsetLeft + element.offsetWidth + (parseFloat(elementStyle.marginRight) || 0);
      var elementWidth = elementEnd - elementStart;
      var nextScrollLeft = track.scrollLeft;
      var visiblePadding = getTrackVisiblePadding(track);

      if (trackPrefersCentering(track)) {
        nextScrollLeft = elementStart - Math.max((trackWidth - elementWidth) / 2, visiblePadding);
      } else {
        var viewportStart = track.scrollLeft;
        var viewportEnd = viewportStart + trackWidth;

        if (elementStart < viewportStart + visiblePadding) {
          nextScrollLeft = elementStart - visiblePadding;
        } else if (elementEnd > viewportEnd - visiblePadding) {
          nextScrollLeft = elementEnd - trackWidth + visiblePadding;
        }
      }

      if (Math.abs(nextScrollLeft - track.scrollLeft) < 1) {
        persistTrackScroll(track);
        return;
      }

      setTrackScroll(track, nextScrollLeft, behavior);
      persistTrackScroll(track);
    });
  }

  function scheduleOptionRootScroll(optionRoot, behavior) {
    if (!optionRoot) {
      return;
    }

    var existingFrames = optionRootFrames.get(optionRoot) || [];

    existingFrames.forEach(window.cancelAnimationFrame);

    var nextFrames = [];
    var frameId = window.requestAnimationFrame(function() {
      var settleFrameId = window.requestAnimationFrame(function() {
        scrollActiveSwatchIntoView(optionRoot, behavior);
      });

      optionRootFrames.set(optionRoot, [settleFrameId]);
    });

    nextFrames.push(frameId);
    optionRootFrames.set(optionRoot, nextFrames);
  }

  function bindProductRerenderListener(form) {
    if (!form || form.__tuokusRerenderBound === true) {
      return;
    }

    form.__tuokusRerenderBound = true;
    form.addEventListener('product:rerender', function() {
      var formId = form.id || null;
      var optionPosition = formId ? lastOptionByForm[formId] : null;
      var key = getOptionKey(formId, optionPosition);

      if (formId && optionPosition) {
        clearFrameBucket(optionRealignFrames, key);
        optionRealignFrames[key] = [];

        realignOption(formId, optionPosition, 'auto');

        optionRealignFrames[key].push(window.requestAnimationFrame(function() {
          realignOption(formId, optionPosition, 'auto');
        }));

        queueOptionRealignSettles(formId, optionPosition, 'auto');

        return;
      }

      queuePickerRealign(formId, 'auto');
    });
  }

  function initProductRerenderBindings() {
    document.querySelectorAll('variant-picker[form-id]').forEach(function(picker) {
      var formId = picker.getAttribute('form-id');

      if (!formId) {
        return;
      }

      bindProductRerenderListener(getFormById(formId));
    });
  }

  function getActiveSwatch(optionRoot) {
    if (!optionRoot) return null;

    return optionRoot.querySelector(
      '.color-swatch__radio:checked + .color-swatch__item,' +
      '.block-swatch__radio:checked + .block-swatch__item,' +
      '.variant-swatch__radio:checked + .variant-swatch__item,' +
      '.color-swatch__item.is-selected,' +
      '.block-swatch__item.is-selected,' +
      '.variant-swatch__item.is-selected'
    );
  }

  function scrollActiveSwatchIntoView(optionRoot, behavior) {
    var activeSwatch = getActiveSwatch(optionRoot);

    if (!activeSwatch || !activeSwatch.closest) {
      return;
    }

    var track = activeSwatch.closest(SWATCH_TRACK_SELECTOR);

    if (!track) {
      return;
    }

    scrollTrackElementIntoView(track, activeSwatch, behavior);
  }

  function queueSwatchScroll(optionRoot, behavior) {
    scheduleOptionRootScroll(optionRoot, behavior);
  }

  function findOptionRoot(formId, optionPosition) {
    if (!formId || !optionPosition) {
      return null;
    }

    var picker = document.querySelector('variant-picker[form-id="' + formId + '"]');

    if (!picker) {
      return null;
    }

    var optionInput = picker.querySelector('[data-option-position="' + optionPosition + '"]');

    return optionInput && optionInput.closest ? optionInput.closest('.product-form__option') : null;
  }

  function realignOption(formId, optionPosition, behavior) {
    var optionRoot = findOptionRoot(formId, optionPosition);

    if (!optionRoot) {
      realignPicker(formId, behavior);
      return;
    }

    restoreOptionScroll(formId, optionPosition, optionRoot);
    scrollActiveSwatchIntoView(optionRoot, behavior);
  }

  function queueOptionRealignSettles(formId, optionPosition, behavior) {
    var key = getOptionKey(formId, optionPosition);

    if (!key) {
      return;
    }

    clearTimerBucket(optionRealignTimers, key);

    optionRealignTimers[key] = [24, 90, 180, 320, 520, 820, 1200].map(function(delay) {
      return window.setTimeout(function() {
        realignOption(formId, optionPosition, behavior);
      }, delay);
    });
  }

  function queueOptionRealign(formId, optionPosition, behavior) {
    var key = getOptionKey(formId, optionPosition);

    if (!key) {
      realignPicker(formId, behavior);
      return;
    }

    clearFrameBucket(optionRealignFrames, key);

    optionRealignFrames[key] = [];

    var frameId = window.requestAnimationFrame(function() {
      realignOption(formId, optionPosition, behavior);

      var settleFrameId = window.requestAnimationFrame(function() {
        realignOption(formId, optionPosition, behavior);
      });

      optionRealignFrames[key] = [settleFrameId];
    });

    optionRealignFrames[key].push(frameId);
    queueOptionRealignSettles(formId, optionPosition, behavior);
  }

  function realignPicker(formId, behavior) {
    initTrackDrag();
    initProductRerenderBindings();

    if (!formId) {
      document.querySelectorAll('variant-picker .product-form__option').forEach(function(optionRoot) {
        scrollActiveSwatchIntoView(optionRoot, behavior);
      });
      return;
    }

    var picker = document.querySelector('variant-picker[form-id="' + formId + '"]');

    if (!picker) {
      return;
    }

    picker.querySelectorAll('.product-form__option').forEach(function(optionRoot) {
      scrollActiveSwatchIntoView(optionRoot, behavior);
    });
  }

  function queuePickerRealign(formId, behavior) {
    var key = formId || '__all__';

    clearFrameBucket(pickerRealignFrames, key);

    pickerRealignFrames[key] = [];

    var frameId = window.requestAnimationFrame(function() {
      realignPicker(formId, behavior);

      var settleFrameId = window.requestAnimationFrame(function() {
        realignPicker(formId, behavior);
      });

      pickerRealignFrames[key] = [settleFrameId];
    });

    pickerRealignFrames[key].push(frameId);
  }

  function findTrack(target) {
    return target && target.closest ? target.closest(SWATCH_TRACK_SELECTOR) : null;
  }

  function findInteractiveRail(target) {
    if (!target || !target.closest) {
      return null;
    }

    return target.closest(SWATCH_TRACK_SELECTOR + ', ' + GENERIC_RAIL_SELECTOR + ', ' + GENERIC_RAIL_TRACK_SELECTOR);
  }

  function shouldSuppressTrackClick(track) {
    if (!track) {
      return false;
    }

    return Number(track.dataset.dragSuppressUntil || 0) > Date.now();
  }

  function finishCurrentTrackDrag(event) {
    var pointerId = event && typeof event.pointerId === 'number' ? event.pointerId : null;
    var track = null;

    if (!dragState) {
      return;
    }

    if (pointerId !== null && dragState.pointerId !== pointerId) {
      return;
    }

    track = dragState.track;

    if (dragState.moved && track) {
      track.dataset.dragSuppressUntil = String(Date.now() + DRAG_SUPPRESS_MS);
    }

    if (track) {
      track.classList.remove('is-swatch-dragging');
    }

    if (track && dragState.pointerCaptured && pointerId !== null && typeof track.hasPointerCapture === 'function' && track.hasPointerCapture(pointerId) && typeof track.releasePointerCapture === 'function') {
      track.releasePointerCapture(pointerId);
    }

    dragState = null;
  }

  function getGalleryRealignKey(sectionRoot) {
    if (!sectionRoot || !sectionRoot.getAttribute) {
      return '__all__';
    }

    return sectionRoot.getAttribute('data-section-id') || '__all__';
  }

  function getSelectedGalleryThumbnail(sectionRoot) {
    if (!sectionRoot || !sectionRoot.querySelector) {
      return null;
    }

    return sectionRoot.querySelector('.product-gallery__thumbnail.is-nav-selected');
  }

  function scrollSelectedGalleryThumbnailIntoView(sectionRoot, behavior) {
    var thumbnail = getSelectedGalleryThumbnail(sectionRoot);
    var track = thumbnail && thumbnail.closest ? thumbnail.closest(GALLERY_TRACK_SELECTOR) : null;

    if (!thumbnail || !track) {
      return;
    }

    scrollTrackElementIntoView(track, thumbnail, behavior);
  }

  function queueGalleryThumbnailRealign(sectionRoot, behavior) {
    var key = getGalleryRealignKey(sectionRoot);

    clearFrameBucket(galleryRealignFrames, key);

    galleryRealignFrames[key] = [];

    var frameId = window.requestAnimationFrame(function() {
      if (sectionRoot) {
        scrollSelectedGalleryThumbnailIntoView(sectionRoot, behavior);
      } else {
        document.querySelectorAll('[data-section-type="product"]').forEach(function(productSection) {
          scrollSelectedGalleryThumbnailIntoView(productSection, behavior);
        });
      }

      var settleFrameId = window.requestAnimationFrame(function() {
        if (sectionRoot) {
          scrollSelectedGalleryThumbnailIntoView(sectionRoot, behavior);
        } else {
          document.querySelectorAll('[data-section-type="product"]').forEach(function(productSection) {
            scrollSelectedGalleryThumbnailIntoView(productSection, behavior);
          });
        }
      });

      galleryRealignFrames[key] = [settleFrameId];
    });

    galleryRealignFrames[key].push(frameId);
  }

  var productGalleryDataCache = Object.create(null);

  function getProductSectionHandle(sectionRoot) {
    var picker = null;

    if (!sectionRoot || !sectionRoot.querySelector) {
      return '';
    }

    picker = sectionRoot.querySelector('variant-picker[handle]');

    return picker ? (picker.getAttribute('handle') || '') : '';
  }

  function getCurrentProductVariantId(sectionRoot) {
    var variantInput = null;

    if (!sectionRoot || !sectionRoot.querySelector) {
      return '';
    }

    variantInput = sectionRoot.querySelector('input[name="id"]');

    return variantInput ? (variantInput.value || '') : '';
  }

  function fetchProductGalleryData(handle) {
    var productUrl = '';

    if (!handle) {
      return Promise.resolve(null);
    }

    if (!productGalleryDataCache[handle]) {
      productUrl = window.Shopify.routes.root + 'products/' + encodeURIComponent(handle) + '.js';

      productGalleryDataCache[handle] = window.fetch(productUrl, { credentials: 'same-origin' }).then(function(response) {
        if (!response.ok) {
          throw new Error('Unable to load product media data');
        }

        return response.json();
      }).catch(function(error) {
        delete productGalleryDataCache[handle];
        throw error;
      });
    }

    return productGalleryDataCache[handle];
  }

  function buildProductMediaVariantMap(productData) {
    var mediaVariantMap = Object.create(null);

    if (!productData || !Array.isArray(productData.variants)) {
      return mediaVariantMap;
    }

    productData.variants.forEach(function(variant) {
      var featuredMedia = variant && variant.featured_media ? variant.featured_media : null;
      var mediaId = featuredMedia && featuredMedia.id ? String(featuredMedia.id) : '';

      if (!mediaId) {
        return;
      }

      if (!mediaVariantMap[mediaId]) {
        mediaVariantMap[mediaId] = [];
      }

      if (mediaVariantMap[mediaId].indexOf(String(variant.id)) === -1) {
        mediaVariantMap[mediaId].push(String(variant.id));
      }
    });

    Object.keys(mediaVariantMap).forEach(function(mediaId) {
      mediaVariantMap[mediaId] = mediaVariantMap[mediaId].join(',');
    });

    return mediaVariantMap;
  }

  function applyProductMediaVariantMap(sectionRoot, mediaVariantMap) {
    if (!sectionRoot || !sectionRoot.querySelectorAll) {
      return;
    }

    sectionRoot.querySelectorAll('.product-gallery__carousel-item, .product-gallery__thumbnail').forEach(function(item) {
      var mediaId = item.getAttribute('data-media-id');
      var variantIdsCsv = mediaId ? mediaVariantMap[String(mediaId)] : '';

      if (variantIdsCsv) {
        item.setAttribute('data-variant-ids', variantIdsCsv);
      }
    });
  }

  function ensureVisibleProductGallerySelection(sectionRoot, variantId) {
    var currentVariantId = variantId ? String(variantId) : String(getCurrentProductVariantId(sectionRoot) || '');
    var currentOptionValueMap = getCurrentOptionValueMap(sectionRoot);
    var visibleCarouselItems = [];
    var visibleThumbnails = [];
    var targetCarouselItem = null;
    var targetMediaId = '';
    var targetThumbnail = null;
    var gallery = null;

    if (!sectionRoot || !sectionRoot.querySelectorAll) {
      return;
    }

    visibleCarouselItems = Array.prototype.slice.call(sectionRoot.querySelectorAll('.product-gallery__carousel-item:not(.is-filtered)'));
    visibleThumbnails = Array.prototype.slice.call(sectionRoot.querySelectorAll('.product-gallery__thumbnail:not(.is-filtered)'));

    if (!visibleCarouselItems.length) {
      return;
    }

    targetCarouselItem = getPreferredVisibleGalleryItem(sectionRoot, visibleCarouselItems, currentVariantId, currentOptionValueMap) || visibleCarouselItems[0];
    targetMediaId = targetCarouselItem.getAttribute('data-media-id') || '';

    sectionRoot.querySelectorAll('.product-gallery__carousel-item.is-selected').forEach(function(item) {
      item.classList.remove('is-selected');
    });

    targetCarouselItem.classList.add('is-selected');

    if (visibleThumbnails.length) {
      targetThumbnail = sectionRoot.querySelector('.product-gallery__thumbnail.is-nav-selected:not(.is-filtered)');

      if (!targetThumbnail || (targetMediaId && targetThumbnail.getAttribute('data-media-id') !== targetMediaId)) {
        targetThumbnail = targetMediaId
          ? sectionRoot.querySelector('.product-gallery__thumbnail[data-media-id="' + targetMediaId + '"]:not(.is-filtered)')
          : visibleThumbnails[0];
      }

      sectionRoot.querySelectorAll('.product-gallery__thumbnail.is-nav-selected').forEach(function(item) {
        item.classList.remove('is-nav-selected');
      });

      if (targetThumbnail) {
        targetThumbnail.classList.add('is-nav-selected');
      }
    }

    gallery = sectionRoot.querySelector('.product-gallery__carousel');

    if (gallery && targetMediaId) {
      gallery.setAttribute('data-initial-media-id', targetMediaId);
    }
  }

  function applySharedGalleryDetailFallback(sectionRoot, currentVariantId) {
    var variantId = currentVariantId ? String(currentVariantId) : '';
    var currentOptionValueMap = getCurrentOptionValueMap(sectionRoot);
    var groupedCarouselItems = Object.create(null);
    var currentGroupKey = '';
    var donorGroupKey = '';
    var donorDetailItems = [];
    var totalVisibleCount = 0;

    if (!sectionRoot || !sectionRoot.querySelectorAll || !variantId) {
      return;
    }

    sectionRoot.querySelectorAll('[data-tuokus-shared-detail="true"]').forEach(function(item) {
      item.removeAttribute('data-tuokus-shared-detail');
    });

    totalVisibleCount = sectionRoot.querySelectorAll('.product-gallery__carousel-item:not(.is-filtered)').length;

    if (totalVisibleCount > 2) {
      return;
    }

    sectionRoot.querySelectorAll('.product-gallery__carousel-item[data-variant-ids]').forEach(function(item) {
      var key = (item.getAttribute('data-variant-ids') || '').trim();

      if (!key) {
        return;
      }

      if (!groupedCarouselItems[key]) {
        groupedCarouselItems[key] = [];
      }

      groupedCarouselItems[key].push(item);

      if (!currentGroupKey && (',' + key + ',').indexOf(',' + variantId + ',') !== -1) {
        currentGroupKey = key;
      }
    });

    if (!currentGroupKey || !groupedCarouselItems[currentGroupKey] || groupedCarouselItems[currentGroupKey].length > 1) {
      return;
    }

    donorGroupKey = Object.keys(groupedCarouselItems).sort(function(a, b) {
      return groupedCarouselItems[b].length - groupedCarouselItems[a].length;
    }).find(function(key) {
      return key !== currentGroupKey && groupedCarouselItems[key].length > 1;
    }) || '';

    if (!donorGroupKey) {
      return;
    }

    donorDetailItems = groupedCarouselItems[donorGroupKey].slice(1, 5);

    donorDetailItems.forEach(function(item) {
      var mediaId = item.getAttribute('data-media-id');

      if (!mediaId) {
        return;
      }

      sectionRoot.querySelectorAll('.product-gallery__carousel-item[data-media-id="' + mediaId + '"], .product-gallery__thumbnail[data-media-id="' + mediaId + '"]').forEach(function(match) {
        match.classList.remove('is-filtered');
        match.setAttribute('data-tuokus-shared-detail', 'true');
      });
    });
  }

  function filterProductGalleryByVariant(sectionRoot, variantId) {
    var currentVariantId = variantId ? String(variantId) : String(getCurrentProductVariantId(sectionRoot) || '');
    var currentOptionValueMap = getCurrentOptionValueMap(sectionRoot);

    if (!sectionRoot || !sectionRoot.querySelectorAll) {
      return;
    }

    sectionRoot.querySelectorAll('.product-gallery__carousel-item, .product-gallery__thumbnail').forEach(function(item) {
      var variantIdsCsv = item.getAttribute('data-variant-ids');
      var groupMatch = getGalleryItemGroupMatch(item, currentOptionValueMap);
      var isVisible = true;

      if (groupMatch !== null) {
        isVisible = groupMatch;
      } else if (currentVariantId && variantIdsCsv) {
        isVisible = matchesVariantIdsCsv(variantIdsCsv, currentVariantId);
      }

      item.classList.toggle('is-filtered', !isVisible);
    });

    if (!sectionRoot.querySelector('.product-gallery__carousel-item:not(.is-filtered)')) {
      restoreVariantPrimaryGalleryMedia(sectionRoot, currentVariantId, currentOptionValueMap);
    }

    applySharedGalleryDetailFallback(sectionRoot, currentVariantId);
    ensureVisibleProductGallerySelection(sectionRoot, currentVariantId);
    refreshProductGalleryLayout(sectionRoot);
  }

  function refreshProductGalleryLayout(sectionRoot) {
    var gallery = null;
    var visibleThumbCount = 0;
    var visibleMediaCount = 0;
    var visibleCount = 0;
    var hasFewVisibleMedia = false;

    if (!sectionRoot || !sectionRoot.querySelector) {
      return;
    }

    gallery = sectionRoot.querySelector('.product-gallery');

    if (!gallery) {
      return;
    }

    visibleThumbCount = sectionRoot.querySelectorAll('.product-gallery__thumbnail:not(.is-filtered)').length;
    visibleMediaCount = sectionRoot.querySelectorAll('.product-gallery__carousel-item:not(.is-filtered)').length;
    visibleCount = visibleThumbCount || visibleMediaCount;
    hasFewVisibleMedia = visibleCount > 1 && visibleCount <= 2;

    gallery.classList.toggle('product-gallery--single-visible-media', visibleCount <= 1);
    gallery.classList.toggle('product-gallery--few-visible-media', hasFewVisibleMedia);
    gallery.setAttribute('data-visible-media-count', String(visibleCount));
  }

  function hydrateProductGalleryMedia(sectionRoot, variantId) {
    var handle = getProductSectionHandle(sectionRoot);

    if (!handle) {
      return Promise.resolve();
    }

    return fetchProductGalleryData(handle).then(function(productData) {
      var mediaVariantMap = buildProductMediaVariantMap(productData);

      applyProductMediaVariantMap(sectionRoot, mediaVariantMap);
      filterProductGalleryByVariant(sectionRoot, variantId);
      queueGalleryThumbnailRealign(sectionRoot, 'auto');
    }).catch(function() {
      return null;
    });
  }

  function hydrateAllProductGalleries() {
    document.querySelectorAll('[data-section-type="product"]').forEach(function(sectionRoot) {
      hydrateProductGalleryMedia(sectionRoot);
    });
  }

  function scheduleProductGalleryHydration(sectionRoot, variantId) {
    [0, 80, 220, 480, 900].forEach(function(delay) {
      window.setTimeout(function() {
        if (sectionRoot && document.body.contains(sectionRoot)) {
          hydrateProductGalleryMedia(sectionRoot, variantId);
        } else if (!sectionRoot) {
          hydrateAllProductGalleries();
        }
      }, delay);
    });
  }

  function bindTrackDrag(track) {
    if (!track || track.__tuokusDragBound === true) {
      return;
    }

    track.__tuokusDragBound = 'native';
    track.style.setProperty('touch-action', 'pan-x pan-y pinch-zoom', 'important');
    track.style.setProperty('-webkit-overflow-scrolling', 'touch', 'important');
    track.style.setProperty('overscroll-behavior-x', 'contain', 'important');
    track.style.setProperty('scroll-behavior', 'auto', 'important');
    track.querySelectorAll('img').forEach(function(image) {
      image.setAttribute('draggable', 'false');
    });

    return;

    track.__tuokusDragBound = true;
    track.addEventListener('dragstart', function(event) {
      if (event.target && event.target.closest && event.target.closest(SWATCH_INTERACTIVE_SELECTOR)) {
        event.preventDefault();
      }
    });

    track.addEventListener('pointerdown', function(event) {
      if (typeof event.button === 'number' && event.button !== 0) {
        return;
      }

      if (track.scrollWidth <= track.clientWidth + 1) {
        return;
      }

      dragState = {
        pointerId: event.pointerId,
        track: track,
        pointerType: event.pointerType || 'mouse',
        startX: event.clientX,
        startY: event.clientY,
        startScrollLeft: track.scrollLeft,
        moved: false,
        pointerCaptured: false
      };
    });

    track.addEventListener('pointermove', function(event) {
      if (!dragState || dragState.track !== track || dragState.pointerId !== event.pointerId) {
        return;
      }

      var deltaX = event.clientX - dragState.startX;
      var deltaY = event.clientY - dragState.startY;
      var absDeltaX = Math.abs(deltaX);
      var absDeltaY = Math.abs(deltaY);
      var isMousePointer = dragState.pointerType === 'mouse';
      var movementThreshold = isMousePointer ? DRAG_THRESHOLD_MOUSE : DRAG_THRESHOLD_TOUCH;

      if (!dragState.moved && absDeltaX > movementThreshold && absDeltaX > absDeltaY) {
        dragState.moved = true;
        track.classList.add('is-swatch-dragging');

        if (typeof track.setPointerCapture === 'function') {
          track.setPointerCapture(event.pointerId);
          dragState.pointerCaptured = true;
        }
      }

      if (dragState.moved) {
        event.preventDefault();
        track.scrollLeft = dragState.startScrollLeft - deltaX;
      }
    });

    function clearDrag(event) {
      if (!dragState || dragState.track !== track) {
        return;
      }

      finishCurrentTrackDrag(event);
    }

    track.addEventListener('pointerup', clearDrag);
    track.addEventListener('pointercancel', clearDrag);
    track.addEventListener('lostpointercapture', function() {
      if (!dragState || dragState.track !== track) {
        return;
      }

      track.classList.remove('is-swatch-dragging');
      dragState = null;
    });
    track.addEventListener('scroll', function() {
      persistTrackScroll(track);
    }, { passive: true });
  }

  function initTrackDrag() {
    document.querySelectorAll(SWATCH_TRACK_SELECTOR).forEach(bindTrackDrag);
  }

  function finishGenericRailDrag(event) {
    var pointerId = event && typeof event.pointerId === 'number' ? event.pointerId : null;
    var track = null;

    if (!genericRailDragState) {
      return;
    }

    if (pointerId !== null && genericRailDragState.pointerId !== pointerId) {
      return;
    }

    track = genericRailDragState.track;

    if (genericRailDragState.moved && track) {
      track.dataset.dragSuppressUntil = String(Date.now() + DRAG_SUPPRESS_MS);
    }

    if (track) {
      track.classList.remove('is-tuokus-rail-dragging');
    }

    if (track && genericRailDragState.pointerCaptured && pointerId !== null && typeof track.hasPointerCapture === 'function' && track.hasPointerCapture(pointerId) && typeof track.releasePointerCapture === 'function') {
      track.releasePointerCapture(pointerId);
    }

    genericRailDragState = null;
  }

  function getGenericRailTrack(element) {
    if (!element) {
      return null;
    }
    
    return element;
  }

  function bindGenericRailDrag(track) {
    if (!track || track.__tuokusGenericDragBound === true) {
      return;
    }

    track.__tuokusGenericDragBound = 'native';
    track.setAttribute('data-tuokus-drag-track', 'native');
    track.style.setProperty('touch-action', 'pan-x pan-y pinch-zoom', 'important');
    track.style.setProperty('-webkit-overflow-scrolling', 'touch', 'important');
    track.style.setProperty('overscroll-behavior-x', 'contain', 'important');
    track.style.setProperty('scroll-behavior', 'auto', 'important');
    track.querySelectorAll('img').forEach(function(image) {
      image.setAttribute('draggable', 'false');
    });

    return;

    track.__tuokusGenericDragBound = true;
    track.setAttribute('data-tuokus-drag-track', 'generic');
    track.querySelectorAll('img').forEach(function(image) {
      image.setAttribute('draggable', 'false');
    });

    track.addEventListener('dragstart', function(event) {
      if (event.target && event.target.closest) {
        event.preventDefault();
      }
    });

    track.addEventListener('pointerdown', function(event) {
      if (typeof event.button === 'number' && event.button !== 0) {
        return;
      }

      if (track.scrollWidth <= track.clientWidth + 1) {
        return;
      }

      genericRailDragState = {
        pointerId: event.pointerId,
        track: track,
        pointerType: event.pointerType || 'mouse',
        startX: event.clientX,
        startY: event.clientY,
        startScrollLeft: track.scrollLeft,
        moved: false,
        pointerCaptured: false
      };
    });

    track.addEventListener('pointermove', function(event) {
      if (!genericRailDragState || genericRailDragState.track !== track || genericRailDragState.pointerId !== event.pointerId) {
        return;
      }

      var deltaX = event.clientX - genericRailDragState.startX;
      var deltaY = event.clientY - genericRailDragState.startY;
      var absDeltaX = Math.abs(deltaX);
      var absDeltaY = Math.abs(deltaY);
      var isMousePointer = genericRailDragState.pointerType === 'mouse';
      var movementThreshold = isMousePointer ? DRAG_THRESHOLD_MOUSE : DRAG_THRESHOLD_TOUCH;

      if (!genericRailDragState.moved && absDeltaX > movementThreshold && absDeltaX > absDeltaY) {
        genericRailDragState.moved = true;
        track.classList.add('is-tuokus-rail-dragging');

        if (typeof track.setPointerCapture === 'function') {
          track.setPointerCapture(event.pointerId);
          genericRailDragState.pointerCaptured = true;
        }
      }

      if (genericRailDragState.moved) {
        event.preventDefault();
        track.scrollLeft = genericRailDragState.startScrollLeft - deltaX;
      }
    });

    function clearGenericRailDrag(event) {
      if (!genericRailDragState || genericRailDragState.track !== track) {
        return;
      }

      finishGenericRailDrag(event);
    }

    track.addEventListener('pointerup', clearGenericRailDrag);
    track.addEventListener('pointercancel', clearGenericRailDrag);
    track.addEventListener('lostpointercapture', function() {
      if (!genericRailDragState || genericRailDragState.track !== track) {
        return;
      }

      track.classList.remove('is-tuokus-rail-dragging');
      genericRailDragState = null;
    });

    track.addEventListener('touchstart', function(event) {
      var touch = null;

      if (!event.touches || event.touches.length !== 1) {
        return;
      }

      if (track.scrollWidth <= track.clientWidth + 1) {
        return;
      }

      touch = event.touches[0];

      genericRailDragState = {
        pointerId: null,
        track: track,
        pointerType: 'touch',
        startX: touch.clientX,
        startY: touch.clientY,
        startScrollLeft: track.scrollLeft,
        moved: false,
        pointerCaptured: false,
        touchIdentifier: touch.identifier
      };
    }, { passive: true });

    track.addEventListener('touchmove', function(event) {
      var touch = null;
      var deltaX = 0;
      var deltaY = 0;
      var absDeltaX = 0;
      var absDeltaY = 0;

      if (!genericRailDragState || genericRailDragState.track !== track || genericRailDragState.pointerType !== 'touch') {
        return;
      }

      touch = Array.from(event.changedTouches || []).find(function(item) {
        return item.identifier === genericRailDragState.touchIdentifier;
      }) || event.touches[0];

      if (!touch) {
        return;
      }

      deltaX = touch.clientX - genericRailDragState.startX;
      deltaY = touch.clientY - genericRailDragState.startY;
      absDeltaX = Math.abs(deltaX);
      absDeltaY = Math.abs(deltaY);

      if (!genericRailDragState.moved && absDeltaX > DRAG_THRESHOLD_TOUCH && absDeltaX > absDeltaY) {
        genericRailDragState.moved = true;
        track.classList.add('is-tuokus-rail-dragging');
      }

      if (genericRailDragState.moved) {
        event.preventDefault();
        track.scrollLeft = genericRailDragState.startScrollLeft - deltaX;
      }
    }, { passive: false });

    function clearGenericTouchDrag() {
      if (!genericRailDragState || genericRailDragState.track !== track || genericRailDragState.pointerType !== 'touch') {
        return;
      }

      finishGenericRailDrag();
    }

    track.addEventListener('touchend', clearGenericTouchDrag, { passive: true });
    track.addEventListener('touchcancel', clearGenericTouchDrag, { passive: true });
  }

  function initGenericRailDrag() {
    document.querySelectorAll(GENERIC_RAIL_SELECTOR).forEach(function(element) {
      bindGenericRailDrag(getGenericRailTrack(element));
    });
  }

  function scheduleGenericRailInit() {
    if (genericRailInitFrame) {
      return;
    }

    genericRailInitFrame = window.requestAnimationFrame(function() {
      genericRailInitFrame = 0;
      initGenericRailDrag();
    });
  }

  function ensureGenericRailObserver() {
    if (genericRailObserver || typeof MutationObserver === 'undefined' || !document.body) {
      return;
    }

    genericRailObserver = new MutationObserver(function(mutations) {
      var shouldRefresh = mutations.some(function(mutation) {
        return mutation.addedNodes && mutation.addedNodes.length > 0;
      });

      if (shouldRefresh) {
        scheduleGenericRailInit();
      }
    });

    genericRailObserver.observe(document.body, { childList: true, subtree: true });
  }

  /* Legacy mojibake support-copy shim superseded by the final reconciler below.
  function normalizeProductSupportCopy(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var supportTitles = ['銈点偆銈恒伀銇ゃ亜銇?, '銇婃墜鍏ャ倢鏂规硶', '閰嶉€併兓杩斿搧銇仱銇勩仸'];
    var refundMarkup = [
      '<h2>閰嶉€併兓杩斿搧銉濄儶銈枫兗銇仱銇勩仸</h2>',
      '<p>銇旀敞鏂囧緦銇€氬父 8銆?1 鏃ュ墠寰屻仹銇亰灞娿亼銈掔洰瀹夈仺銇椼仸銇勩伨銇欍€傚湴鍩熴倓閰嶉€佺姸娉併伀銈堛倞鍓嶅緦銇欍倠鍫村悎銇屻亗銈娿伨銇欍伄銇с€併亗銈夈亱銇樸倎銇斾簡鎵裤亸銇犮仌銇勩€?/p>',
      '<h3>杩斿搧銇仱銇勩仸</h3>',
      '<p>涓囦竴銆佸晢鍝併伀涓嶅叿鍚堛倓鐮存悕銇屻亗銇ｃ仧鍫村悎銇€佸晢鍝佸埌鐫€寰屻仹銇嶃倠銇犮亼鏃┿亸銇旈€ｇ怠銇忋仩銇曘亜銆傚唴瀹广倰纰鸿獚銇亞銇堛€佷氦鎻涖伨銇熴伅杩斿搧銇祦銈屻倰銇旀鍐呫仐銇俱仚銆?/p>',
      '<h3>銇旂⒑瑾嶄簨闋?/h3>',
      '<p>銇斾娇鐢ㄥ緦銇睔銈屻倓銇婂銇曘伨閮藉悎銇с伄杩斿搧鏉′欢銇仼銆佽┏绱般伅銈广儓銈伄閰嶉€併儩銉偡銉笺兓杩斿搧銉濄儶銈枫兗銈掋仈纰鸿獚銇忋仩銇曘亜銆?/p>'
    ].join('');

    scope.querySelectorAll('[data-section-type="product"]').forEach(function(sectionRoot) {
      sectionRoot.querySelectorAll('.product-block-list__item--content .card__title').forEach(function(title, index) {
        var currentText = (title.textContent || '').trim();

        if (index >= supportTitles.length) {
          return;
        }

        if (!currentText || !/[銇?銈撱偂-銉躲兗]/.test(currentText) || /[锟絔/.test(currentText)) {
          title.textContent = supportTitles[index];
        }
      });

      sectionRoot.querySelectorAll('.product-block-list__item--description .card__title').forEach(function(title) {
        title.textContent = '鍟嗗搧瑭崇窗';
      });

      sectionRoot.querySelectorAll('.product-block-list__item--reviews .card__title').forEach(function(title) {
        title.textContent = '銉儞銉ャ兗';
      });

      sectionRoot.querySelectorAll('#modal-refunds-policy .rte').forEach(function(content) {
        var text = (content.textContent || '').trim();

        if (text && /[锟絔|閺墊闁竱濡祙閵?.test(text)) {
          content.innerHTML = refundMarkup;
        }
      });
    });
  }
  */

  function normalizeProductSupportCopy(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var supportTitles = ['サイズについて', 'お手入れ方法', '配送・返品について'];
    var refundMarkup = [
      '<h2>配送・返品ポリシーについて</h2>',
      '<p>日本へのお届け目安は通常8〜11日です。地域や配送状況により前後する場合がありますので、あらかじめご了承ください。</p>',
      '<h3>返品について</h3>',
      '<p>商品に不具合や破損があった場合は、商品到着後できるだけ早くご連絡ください。内容を確認のうえ、交換または返品の流れをご案内いたします。</p>',
      '<h3>ご確認事項</h3>',
      '<p>ご使用後の汚れやお客様都合での返品条件など、詳しくはストアの配送・返品ポリシーをご確認ください。</p>'
    ].join('');
    var mojibakePattern = /[\uFFFD]|(?:Â|Ã|銈|銉|鍟|鏃|閰|闁|閵|杩|搧|瑭|崇)/;

    scope.querySelectorAll('[data-section-type="product"]').forEach(function(sectionRoot) {
      sectionRoot.querySelectorAll('.product-block-list__item--description .card__title').forEach(function(title) {
        var currentText = (title.textContent || '').trim();

        if (!currentText || mojibakePattern.test(currentText)) {
          title.textContent = '商品詳細';
        }
      });

      sectionRoot.querySelectorAll('.product-block-list__item--content .card__title').forEach(function(title, index) {
        var currentText = (title.textContent || '').trim();

        if (index >= supportTitles.length) {
          return;
        }

        if (!currentText || mojibakePattern.test(currentText)) {
          title.textContent = supportTitles[index];
        }
      });

      sectionRoot.querySelectorAll('.product-block-list__item--reviews .card__title').forEach(function(title) {
        var currentText = (title.textContent || '').trim();

        if (!currentText || mojibakePattern.test(currentText)) {
          title.textContent = 'レビュー';
        }
      });

      sectionRoot.querySelectorAll('#modal-refunds-policy .rte').forEach(function(content) {
        var text = (content.textContent || '').trim();

        if (!text || mojibakePattern.test(text)) {
          content.innerHTML = refundMarkup;
        }
      });
    });
  }

  function onVariantOptionInteraction(target) {
    var optionRoot = target && target.closest ? target.closest('.product-form__option') : null;
    var optionInput = null;
    var formId = null;
    var optionPosition = null;

    if (target && target.matches && target.matches('.product-form__single-selector[data-option-position]')) {
      optionInput = target;
    } else if (target && target.getAttribute) {
      var targetFor = target.getAttribute('for');

      if (targetFor) {
        optionInput = document.getElementById(targetFor);
      }
    }

    if (optionInput) {
      formId = optionInput.getAttribute('form') || (optionInput.form ? optionInput.form.id : null);
      optionPosition = optionInput.getAttribute('data-option-position');
    }

    if (formId && optionPosition) {
      rememberOptionScroll(formId, optionPosition, optionRoot);

      if (formUsesProductRerender(formId)) {
        queueOptionRealign(formId, optionPosition, 'auto');
      }

      return;
    }

    if (!optionRoot) {
      return;
    }

    queueSwatchScroll(optionRoot, 'auto');
  }

  document.addEventListener('change', function(event) {
    var target = event.target;

    if (!target || !target.matches || !target.matches(
      '.product-form__single-selector[data-option-position], ' +
      '.color-swatch__radio, ' +
      '.block-swatch__radio, ' +
      '.variant-swatch__radio'
    )) {
      return;
    }

    onVariantOptionInteraction(target);

    if (target.matches('.product-form__single-selector[data-option-position]')) {
      scheduleForcedVariantSync(target);
    }
  });

  document.addEventListener('pointerdown', function(event) {
    rememberOptionScrollFromTarget(event.target);
  }, true);

  document.addEventListener('click', function(event) {
    var track = findInteractiveRail(event.target);

    if (!shouldSuppressTrackClick(track)) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  document.addEventListener('click', function(event) {
    var track = findInteractiveRail(event.target);

    if (shouldSuppressTrackClick(track)) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    var label = event.target.closest(
      '.variant-swatch__item, .block-swatch__item, .color-swatch__item'
    );

    if (!label || !label.getAttribute('for')) {
      return;
    }

    var control = document.getElementById(label.getAttribute('for'));

    if (!control || !control.matches('.product-form__single-selector[data-option-position]') || control.disabled || control.checked) {
      return;
    }

    var optionRoot = label.closest('.product-form__option');
    var formId = control.getAttribute('form') || (control.form ? control.form.id : null);
    var optionPosition = control.getAttribute('data-option-position');

    if (formId && optionPosition) {
      rememberOptionScroll(formId, optionPosition, optionRoot);
    }

    control.checked = true;
    control.dispatchEvent(new Event('change', { bubbles: true }));
    queueSwatchScroll(optionRoot, 'smooth');
    scheduleForcedVariantSync(control);
  });

  document.addEventListener('pointerup', finishCurrentTrackDrag, true);
  document.addEventListener('pointercancel', finishCurrentTrackDrag, true);
  document.addEventListener('pointerup', finishGenericRailDrag, true);
  document.addEventListener('pointercancel', finishGenericRailDrag, true);
  window.addEventListener('blur', function() {
    finishCurrentTrackDrag();
    finishGenericRailDrag();
  });

  document.addEventListener('variant:changed', function(event) {
    var form = event.target;
    var formId = null;
    var optionPosition = null;
    var sectionRoot = null;

    if (form) {
      formId = form.id || (form.getAttribute ? form.getAttribute('form-id') : null);
      sectionRoot = form.closest ? form.closest('[data-section-type="product"]') : null;
    }

    if (!formId && event.detail && event.detail.formId) {
      formId = event.detail.formId;
    }

    if (formId) {
      optionPosition = lastOptionByForm[formId] || null;
    }

    if (formUsesProductRerender(formId)) {
      return;
    }

    if (!formId) {
      document.querySelectorAll('variant-picker .product-form__option').forEach(function(optionRoot) {
        queueSwatchScroll(optionRoot, 'smooth');
      });

      queueGalleryThumbnailRealign(null, 'smooth');
      scheduleProductGalleryHydration(null);
      return;
    }

    if (optionPosition) {
      queueOptionRealign(formId, optionPosition, 'smooth');
    } else {
      queuePickerRealign(formId, 'smooth');
    }

    queueGalleryThumbnailRealign(sectionRoot, 'smooth');
    scheduleProductGalleryHydration(sectionRoot, event.detail && event.detail.variant ? event.detail.variant.id : null);
  });

  document.addEventListener('product:rerender', function(event) {
    var formId = event.detail && event.detail.formId ? event.detail.formId : null;

    window.setTimeout(function() {
      var form = formId ? document.getElementById(formId) : null;
      var sectionRoot = form && form.closest ? form.closest('[data-section-type="product"]') : null;

      normalizeProductSupportCopy(sectionRoot || document);

      if (sectionRoot) {
        scheduleProductGalleryHydration(sectionRoot);
      } else {
        scheduleProductGalleryHydration(null);
      }
    }, 0);
  });

  document.addEventListener('click', function(event) {
    var thumbnail = event.target.closest('.product-gallery__thumbnail');
    var sectionRoot = null;

    if (!thumbnail) {
      return;
    }

    sectionRoot = thumbnail.closest('[data-section-type="product"]');
    queueGalleryThumbnailRealign(sectionRoot, 'smooth');
  });

  document.addEventListener('theme:loading:end', function() {
    initTrackDrag();
    initGenericRailDrag();
    ensureGenericRailObserver();
    initProductRerenderBindings();
    scheduleProductGalleryHydration(null);
    normalizeProductSupportCopy();
    document.querySelectorAll('variant-picker .product-form__option').forEach(function(optionRoot) {
      scrollActiveSwatchIntoView(optionRoot, 'auto');
    });
    queueGalleryThumbnailRealign(null, 'auto');
  });

  document.addEventListener('shopify:section:load', function(event) {
    var sectionRoot = event.target && event.target.matches && event.target.matches('[data-section-type="product"]')
      ? event.target
      : event.target && event.target.querySelector
        ? event.target.querySelector('[data-section-type="product"]')
        : null;

    if (!sectionRoot) {
      return;
    }

    initTrackDrag();
    initGenericRailDrag();
    ensureGenericRailObserver();
    initProductRerenderBindings();
    normalizeProductSupportCopy(sectionRoot);
    scheduleProductGalleryHydration(sectionRoot);
    sectionRoot.querySelectorAll('variant-picker .product-form__option').forEach(function(optionRoot) {
      scrollActiveSwatchIntoView(optionRoot, 'auto');
    });
    queueGalleryThumbnailRealign(sectionRoot, 'auto');
  });

  function initTuokusProductInteractions() {
    initTrackDrag();
    initGenericRailDrag();
    ensureGenericRailObserver();
    initProductRerenderBindings();
    scheduleProductGalleryHydration(null);
    normalizeProductSupportCopy();
    document.querySelectorAll('variant-picker .product-form__option').forEach(function(optionRoot) {
      scrollActiveSwatchIntoView(optionRoot, 'auto');
    });
    queueGalleryThumbnailRealign(null, 'auto');
  }

  window.addEventListener('pageshow', function() {
    initTrackDrag();
    initGenericRailDrag();
    ensureGenericRailObserver();
    initProductRerenderBindings();
    scheduleProductGalleryHydration(null);
    document.querySelectorAll('variant-picker .product-form__option').forEach(function(optionRoot) {
      scrollActiveSwatchIntoView(optionRoot, 'auto');
    });
    queueGalleryThumbnailRealign(null, 'auto');
  });

  document.addEventListener('DOMContentLoaded', function() {
    initTuokusProductInteractions();
  });

  if (document.readyState !== 'loading') {
    initTuokusProductInteractions();
  }

  function applySharedGalleryDetailFallback(sectionRoot, currentVariantId) {
    var variantId = currentVariantId ? String(currentVariantId) : '';
    var currentOptionValueMap = getCurrentOptionValueMap(sectionRoot);
    var groupedCarouselItems = Object.create(null);
    var currentGroupKey = '';
    var donorGroupKey = '';
    var donorDetailItems = [];
    var totalVisibleCount = 0;

    if (!sectionRoot || !sectionRoot.querySelectorAll || !variantId) {
      return;
    }

    sectionRoot.querySelectorAll('[data-tuokus-shared-detail="true"]').forEach(function(item) {
      item.removeAttribute('data-tuokus-shared-detail');
      item.removeAttribute('data-tuokus-shared-detail-active');
    });

    totalVisibleCount = sectionRoot.querySelectorAll('.product-gallery__carousel-item:not(.is-filtered)').length;

    if (totalVisibleCount > 2) {
      return;
    }

    sectionRoot.querySelectorAll('.product-gallery__carousel-item[data-variant-ids]').forEach(function(item) {
      var key = (item.getAttribute('data-variant-ids') || '').trim();

      if (!key) {
        return;
      }

      if (!groupedCarouselItems[key]) {
        groupedCarouselItems[key] = [];
      }

      groupedCarouselItems[key].push(item);

      if (!currentGroupKey && (',' + key + ',').indexOf(',' + variantId + ',') !== -1) {
        currentGroupKey = key;
      }
    });

    if (!currentGroupKey || !groupedCarouselItems[currentGroupKey] || groupedCarouselItems[currentGroupKey].length > 1) {
      return;
    }

    donorGroupKey = Object.keys(groupedCarouselItems).sort(function(a, b) {
      return groupedCarouselItems[b].length - groupedCarouselItems[a].length;
    }).find(function(key) {
      return key !== currentGroupKey && groupedCarouselItems[key].length > 1;
    }) || '';

    if (!donorGroupKey) {
      return;
    }

    donorDetailItems = groupedCarouselItems[donorGroupKey].slice(1, 5);

    donorDetailItems.forEach(function(item) {
      var mediaId = item.getAttribute('data-media-id');
      var carouselItem = null;
      var thumbnail = null;

      if (!mediaId) {
        return;
      }

      carouselItem = sectionRoot.querySelector('.product-gallery__carousel-item[data-media-id="' + mediaId + '"]');
      thumbnail = sectionRoot.querySelector('.product-gallery__thumbnail[data-media-id="' + mediaId + '"]');

      if (carouselItem) {
        carouselItem.classList.add('is-filtered');
        carouselItem.classList.remove('is-selected');
        carouselItem.setAttribute('data-tuokus-shared-detail', 'true');
      }

      if (thumbnail) {
        thumbnail.classList.remove('is-filtered');
        thumbnail.setAttribute('data-tuokus-shared-detail', 'true');
      }
    });
  }

  function resetSharedGalleryDetailMedia(sectionRoot) {
    if (!sectionRoot || !sectionRoot.querySelectorAll) {
      return;
    }

    sectionRoot.querySelectorAll('.product-gallery__carousel-item[data-tuokus-shared-detail="true"]').forEach(function(item) {
      item.classList.add('is-filtered');
      item.classList.remove('is-selected');
      item.removeAttribute('data-tuokus-shared-detail-active');
    });
  }

  function revealSharedGalleryDetailMedia(sectionRoot, mediaId) {
    var targetCarouselItem = null;
    var targetThumbnail = null;

    if (!sectionRoot || !mediaId) {
      return false;
    }

    targetCarouselItem = sectionRoot.querySelector('.product-gallery__carousel-item[data-media-id="' + mediaId + '"][data-tuokus-shared-detail="true"]');
    targetThumbnail = sectionRoot.querySelector('.product-gallery__thumbnail[data-media-id="' + mediaId + '"][data-tuokus-shared-detail="true"]');

    if (!targetCarouselItem && !targetThumbnail) {
      resetSharedGalleryDetailMedia(sectionRoot);
      return false;
    }

    resetSharedGalleryDetailMedia(sectionRoot);

    if (targetCarouselItem) {
      targetCarouselItem.classList.remove('is-filtered');
      targetCarouselItem.setAttribute('data-tuokus-shared-detail-active', 'true');
    }

    if (targetThumbnail) {
      targetThumbnail.classList.remove('is-filtered');
    }

    return true;
  }

  /* Legacy duplicate support-copy shim superseded by the final reconciler below.
  function normalizeProductSupportCopy(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var supportTitles = ['銈点偆銈恒伀銇ゃ亜銇?, '銇婃墜鍏ャ倢鏂规硶', '閰嶉€併兓杩斿搧銇仱銇勩仸'];
    var mojibakePattern = /[閵囬妶閸熼柊闂侀敓\uFFFD]/;
    var refundMarkup = [
      '<h2>閰嶉€併兓杩斿搧銉濄儶銈枫兗銇仱銇勩仸</h2>',
      '<p>鏃ユ湰銇搞伄銇婂眾銇戠洰瀹夈伅閫氬父 8銆?1 鏃ャ仹銇欍€傚湴鍩熴倓閰嶉€佺姸娉併伀銈堛倞鍓嶅緦銇欍倠鍫村悎銇屻亗銈娿伨銇欍伄銇с€併亗銈夈亱銇樸倎銇斾簡鎵裤亸銇犮仌銇勩€?/p>',
      '<h3>杩斿搧銇仱銇勩仸</h3>',
      '<p>鍟嗗搧銇笉鍏峰悎銈勭牬鎼嶃亴銇傘仯銇熷牬鍚堛伅銆佸埌鐫€寰屻仹銇嶃倠銇犮亼鏃┿亸銇旈€ｇ怠銇忋仩銇曘亜銆傚唴瀹广倰纰鸿獚銇亞銇堛€佷氦鎻涖伨銇熴伅杩斿搧銇祦銈屻倰銇旀鍐呫仐銇俱仚銆?/p>',
      '<h3>銇旂⒑瑾嶄簨闋?/h3>',
      '<p>銇斾娇鐢ㄥ緦銇睔銈屻倓銇婂銇曘伨閮藉悎銇с伄杩斿搧鏉′欢銇仼銆佽┏绱般伅銈广儓銈伄閰嶉€併兓杩斿搧銉濄儶銈枫兗銈掋仈纰鸿獚銇忋仩銇曘亜銆?/p>'
    ].join('');

    scope.querySelectorAll('[data-section-type="product"]').forEach(function(sectionRoot) {
      sectionRoot.querySelectorAll('.product-block-list__item--content .card__title').forEach(function(title, index) {
        if (index >= supportTitles.length) {
          return;
        }

        title.textContent = supportTitles[index];
      });

      sectionRoot.querySelectorAll('.product-block-list__item--description .card__title').forEach(function(title) {
        title.textContent = '鍟嗗搧瑭崇窗';
      });

      sectionRoot.querySelectorAll('.product-block-list__item--reviews .card__title').forEach(function(title) {
        title.textContent = '銉儞銉ャ兗';
      });

      sectionRoot.querySelectorAll('#modal-refunds-policy .rte').forEach(function(content) {
        var text = (content.textContent || '').trim();

        if (text && mojibakePattern.test(text)) {
          content.innerHTML = refundMarkup;
        }
      });
    });
  }
  */

  document.addEventListener('click', function(event) {
    var thumbnail = event.target.closest('.product-gallery__thumbnail');
    var sectionRoot = null;
    var mediaId = '';

    if (!thumbnail) {
      return;
    }

    sectionRoot = thumbnail.closest('[data-section-type="product"]');
    mediaId = thumbnail.getAttribute('data-media-id') || '';

    if (thumbnail.hasAttribute('data-tuokus-shared-detail')) {
      revealSharedGalleryDetailMedia(sectionRoot, mediaId);
    } else {
      resetSharedGalleryDetailMedia(sectionRoot);
    }

    window.requestAnimationFrame(function() {
      refreshProductGalleryLayout(sectionRoot);
      queueGalleryThumbnailRealign(sectionRoot, 'smooth');
    });
  }, true);

  function applySharedGalleryDetailFallback(sectionRoot, currentVariantId) {
    var variantId = currentVariantId ? String(currentVariantId) : '';
    var visibleCarouselItems = [];
    var primaryCarouselItem = null;
    var currentOptionValueMap = getCurrentOptionValueMap(sectionRoot);

    if (!sectionRoot || !sectionRoot.querySelectorAll || !variantId) {
      return;
    }

    sectionRoot.querySelectorAll('[data-tuokus-shared-detail="true"]').forEach(function(item) {
      item.removeAttribute('data-tuokus-shared-detail');
      item.removeAttribute('data-tuokus-shared-detail-active');
    });

    visibleCarouselItems = Array.prototype.slice.call(sectionRoot.querySelectorAll('.product-gallery__carousel-item:not(.is-filtered)'));
    primaryCarouselItem = getPreferredVisibleGalleryItem(sectionRoot, visibleCarouselItems, variantId, currentOptionValueMap);

    visibleCarouselItems.forEach(function(item) {
      var mediaId = '';
      var thumbnail = null;

      if (!primaryCarouselItem || item === primaryCarouselItem) {
        return;
      }

      mediaId = item.getAttribute('data-media-id') || '';
      thumbnail = mediaId ? sectionRoot.querySelector('.product-gallery__thumbnail[data-media-id="' + mediaId + '"]') : null;

      item.classList.add('is-filtered');
      item.classList.remove('is-selected');
      item.setAttribute('data-tuokus-shared-detail', 'true');

      if (thumbnail) {
        thumbnail.classList.remove('is-filtered');
        thumbnail.setAttribute('data-tuokus-shared-detail', 'true');
      }
    });
  }

  function resetSharedGalleryDetailMedia(sectionRoot) {
    if (!sectionRoot || !sectionRoot.querySelectorAll) {
      return;
    }

    sectionRoot.querySelectorAll('.product-gallery__carousel-item[data-tuokus-shared-detail="true"]').forEach(function(item) {
      item.classList.add('is-filtered');
      item.classList.remove('is-selected');
      item.removeAttribute('data-tuokus-shared-detail-active');
    });
  }

  function revealSharedGalleryDetailMedia(sectionRoot, mediaId) {
    var targetCarouselItem = null;
    var targetThumbnail = null;

    if (!sectionRoot || !mediaId) {
      return false;
    }

    targetCarouselItem = sectionRoot.querySelector('.product-gallery__carousel-item[data-media-id="' + mediaId + '"][data-tuokus-shared-detail="true"]');
    targetThumbnail = sectionRoot.querySelector('.product-gallery__thumbnail[data-media-id="' + mediaId + '"][data-tuokus-shared-detail="true"]');

    if (!targetCarouselItem && !targetThumbnail) {
      resetSharedGalleryDetailMedia(sectionRoot);
      return false;
    }

    resetSharedGalleryDetailMedia(sectionRoot);

    if (targetCarouselItem) {
      sectionRoot.querySelectorAll('.product-gallery__carousel-item.is-selected').forEach(function(item) {
        item.classList.remove('is-selected');
      });

      targetCarouselItem.classList.remove('is-filtered');
      targetCarouselItem.classList.add('is-selected');
      targetCarouselItem.setAttribute('data-tuokus-shared-detail-active', 'true');
    }

    if (targetThumbnail) {
      sectionRoot.querySelectorAll('.product-gallery__thumbnail.is-nav-selected').forEach(function(item) {
        item.classList.remove('is-nav-selected');
      });

      targetThumbnail.classList.remove('is-filtered');
      targetThumbnail.classList.add('is-nav-selected');
    }

    return true;
  }

  /* Legacy duplicate product copy/gallery reconcilers removed in favor of the final product reconciler near the end of this file.

  function normalizeProductSupportCopy(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var supportTitles = ['銈点偆銈恒伀銇ゃ亜銇?, '銇婃墜鍏ャ倢鏂规硶', '閰嶉€併兓杩斿搧銇仱銇勩仸'];
    var mojibakePattern = /[\uFFFD]|[閸熼柊閵囬妶]/;
    var refundMarkup = [
      '<h2>閰嶉€併兓杩斿搧銉濄儶銈枫兗銇仱銇勩仸</h2>',
      '<p>鏃ユ湰銇搞伄銇婂眾銇戠洰瀹夈伅閫氬父8銆?1鏃ャ仹銇欍€傚湴鍩熴倓閰嶉€佺姸娉併伀銈堛倞鍓嶅緦銇欍倠鍫村悎銇屻亗銈娿伨銇欍伄銇с€併亗銈夈亱銇樸倎銇斾簡鎵裤亸銇犮仌銇勩€?/p>',
      '<h3>杩斿搧銇仱銇勩仸</h3>',
      '<p>鍟嗗搧銇笉鍏峰悎銈勭牬鎼嶃亴銇傘仯銇熷牬鍚堛伅銆佸晢鍝佸埌鐫€寰屻仹銇嶃倠銇犮亼鏃┿亸銇旈€ｇ怠銇忋仩銇曘亜銆傚唴瀹广倰纰鸿獚銇亞銇堛€佷氦鎻涖伨銇熴伅杩斿搧銇祦銈屻倰銇旀鍐呫亜銇熴仐銇俱仚銆?/p>',
      '<h3>銇旂⒑瑾嶄簨闋?/h3>',
      '<p>銇斾娇鐢ㄥ緦銇睔銈屻倓銇婂銇曘伨閮藉悎銇с伄杩斿搧鏉′欢銇仼銆佽┏绱般伅銈广儓銈伄閰嶉€併兓杩斿搧銉濄儶銈枫兗銈掋仈纰鸿獚銇忋仩銇曘亜銆?/p>'
    ].join('');

    scope.querySelectorAll('[data-section-type="product"]').forEach(function(sectionRoot) {
      sectionRoot.querySelectorAll('.product-block-list__item--content .card__title').forEach(function(title, index) {
        if (index >= supportTitles.length) {
          return;
        }

        title.textContent = supportTitles[index];
      });

      sectionRoot.querySelectorAll('.product-block-list__item--description .card__title').forEach(function(title) {
        title.textContent = '鍟嗗搧瑭崇窗';
      });

      sectionRoot.querySelectorAll('.product-block-list__item--reviews .card__title').forEach(function(title) {
        title.textContent = '銉儞銉ャ兗';
      });

      sectionRoot.querySelectorAll('#modal-refunds-policy .rte').forEach(function(content) {
        var text = (content.textContent || '').trim();

        if (!text || mojibakePattern.test(text)) {
          content.innerHTML = refundMarkup;
        }
      });
    });
  }
  */
})();

(function() {
  if (window.__TUOKUS_REVIEW_MODAL_20260719) {
    return;
  }

  window.__TUOKUS_REVIEW_MODAL_20260719 = true;
  window.__TUOKUS_REVIEW_UI_BUILD_20260719 = 'review-ui3';

  function getModalFromTrigger(trigger) {
    var reviewBlock = trigger && trigger.closest ? trigger.closest('.product-block-list__item--reviews') : null;

    return reviewBlock ? reviewBlock.querySelector('[data-tuokus-review-modal]') : null;
  }

  function getFocusableElement(modal) {
    return modal ? modal.querySelector('input:not([type="hidden"]), textarea, button, select, [tabindex]:not([tabindex="-1"])') : null;
  }

  function setStatus(form, message, isError) {
    var status = form ? form.querySelector('[data-tuokus-review-status]') : null;

    if (!status) {
      return;
    }

    status.hidden = false;
    status.textContent = message;
    status.classList.toggle('is-error', Boolean(isError));
  }

  function openReviewModal(trigger) {
    var modal = getModalFromTrigger(trigger);
    var focusTarget = null;

    if (!modal) {
      return;
    }

    modal.hidden = false;
    modal.classList.add('is-open');
    modal.dataset.lastFocus = 'true';
    document.documentElement.classList.add('tuokus-review-modal-open');
    document.body.classList.add('tuokus-review-modal-open');

    focusTarget = getFocusableElement(modal);
    if (focusTarget) {
      window.setTimeout(function() {
        try {
          focusTarget.focus({ preventScroll: true });
        } catch (error) {
          focusTarget.focus();
        }
      }, 30);
    }
  }

  function closeReviewModal(modal) {
    if (!modal) {
      return;
    }

    modal.classList.remove('is-open');
    modal.hidden = true;
    document.documentElement.classList.remove('tuokus-review-modal-open');
    document.body.classList.remove('tuokus-review-modal-open');
  }

  function persistPendingReview(form, imageCount) {
    var formData = new FormData(form);
    var records = [];
    var record = {
      createdAt: new Date().toISOString(),
      status: 'pending',
      product: formData.get('contact[商品]') || '',
      productUrl: formData.get('contact[商品URL]') || '',
      rating: formData.get('contact[評価]') || '',
      title: formData.get('contact[レビュータイトル]') || '',
      body: formData.get('contact[body]') || '',
      name: formData.get('contact[name]') || '',
      email: formData.get('contact[email]') || '',
      imageCount: imageCount || 0
    };

    try {
      records = JSON.parse(window.localStorage.getItem('tuokusPendingReviews') || '[]');
      records.unshift(record);
      window.localStorage.setItem('tuokusPendingReviews', JSON.stringify(records.slice(0, 20)));
    } catch (error) {
      return;
    }
  }

  function submitReviewForm(form) {
    var modal = form ? form.closest('[data-tuokus-review-modal]') : null;
    var endpoint = modal ? modal.getAttribute('data-review-endpoint') : '';
    var submitButton = form ? form.querySelector('.product-page__review-submit') : null;
    var imageInput = form ? form.querySelector('[data-tuokus-review-images]') : null;
    var imageCount = imageInput && imageInput.files ? imageInput.files.length : 0;
    var formData = null;
    var target = '';

    if (!form) {
      return;
    }

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = '送信中...';
    }

    formData = new FormData(form);
    target = endpoint || form.getAttribute('action') || window.location.href;

    if (endpoint && imageInput && imageInput.files) {
      Array.prototype.slice.call(imageInput.files, 0, 4).forEach(function(file) {
        formData.append('review_images[]', file);
      });
    }

    fetch(target, {
      method: 'POST',
      body: formData,
      credentials: 'same-origin',
      headers: {
        'Accept': 'text/html,application/json'
      }
    }).then(function(response) {
      if (!response.ok) {
        throw new Error('Review submit failed');
      }

      persistPendingReview(form, imageCount);
      form.reset();
      setStatus(form, 'レビューを受け付けました。承認後に掲載されます。', false);
    }).catch(function() {
      persistPendingReview(form, imageCount);
      setStatus(form, '通信が不安定なため、下書きを承認待ちとして保存しました。もう一度送信できます。', true);
    }).finally(function() {
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent = '送信して承認待ちにする';
      }
    });
  }

  document.addEventListener('click', function(event) {
    var openTrigger = event.target && event.target.closest ? event.target.closest('[data-tuokus-review-open]') : null;
    var closeTrigger = event.target && event.target.closest ? event.target.closest('[data-tuokus-review-close]') : null;

    if (openTrigger) {
      event.preventDefault();
      openReviewModal(openTrigger);
      return;
    }

    if (closeTrigger) {
      event.preventDefault();
      closeReviewModal(closeTrigger.closest('[data-tuokus-review-modal]'));
    }
  });

  document.addEventListener('submit', function(event) {
    var form = event.target && event.target.closest ? event.target.closest('.product-page__review-form') : null;

    if (!form) {
      return;
    }

    event.preventDefault();
    submitReviewForm(form);
  });

  document.addEventListener('change', function(event) {
    var input = event.target && event.target.closest ? event.target.closest('[data-tuokus-review-images]') : null;
    var status = input && input.parentElement ? input.parentElement.querySelector('[data-tuokus-review-image-status]') : null;
    var count = input && input.files ? input.files.length : 0;

    if (!input || !status) {
      return;
    }

    if (count > 4) {
      status.textContent = '写真は4枚まで選択できます。';
      input.value = '';
      return;
    }

    status.textContent = count ? count + '枚の写真を選択しました。' : '最大4枚まで選択できます。現在は投稿内容の確認用です。';
  });

  document.addEventListener('keydown', function(event) {
    var modal = document.querySelector('[data-tuokus-review-modal].is-open');

    if (event.key === 'Escape' && modal) {
      closeReviewModal(modal);
    }
  });
})();
(function() {
  if (window.__TUOKUS_FINAL_RECOVERY_ACTIVE || window.__tuokusLiveRecovery20260711) {
    return;
  }

  window.__tuokusLiveRecovery20260711 = true;

  var PRODUCT_SECTION_SELECTOR = '[data-section-type="product"]';
  var RAIL_SELECTOR = '.variant-swatch-list, .block-swatch-list, .color-swatch-list--large, .tuokus-promo-module__rail, .tuokus-collection-discovery__rail, .product-list--scrollable, .activity-product-list';
  var VARIANT_RAIL_SELECTOR = '.variant-swatch-list, .block-swatch-list, .color-swatch-list--large';
  var COUPON_BUTTON_SELECTOR = '[data-copy-coupon], [data-coupon-copy-button]';
  var lastCopyState = {
    button: null,
    time: 0
  };

  function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList || []);
  }

  function isMobileViewport() {
    return window.innerWidth <= 999;
  }

  function getProductSection(node) {
    return node && node.closest ? node.closest(PRODUCT_SECTION_SELECTOR) : null;
  }

  function removeFilterState(node) {
    if (!node) {
      return;
    }

    node.hidden = false;
    node.classList.remove('is-filtered');
    node.removeAttribute('aria-hidden');
  }

  function isSharedMediaNode(node) {
    var sharedFlag = '';
    var variantIds = '';

    if (!node || !node.getAttribute) {
      return false;
    }

    sharedFlag = String(node.getAttribute('data-tuokus-shared-detail') || '').toLowerCase();
    variantIds = String(node.getAttribute('data-variant-ids') || '').replace(/\s+/g, '');

    return sharedFlag === 'true' || sharedFlag === '1' || variantIds === '';
  }

  function getVisibleNodes(nodes) {
    return nodes.filter(function(node) {
      return !node.classList.contains('is-filtered');
    });
  }

  function forceProductBlockOrder(sectionRoot) {
    var titleBlock = null;
    var galleryBlock = null;
    var infoBlock = null;
    var promotionBlock = null;
    var variantBlock = null;
    var variantPicker = null;
    var infoList = null;
    var pricingPanel = null;

    if (!sectionRoot || !isMobileViewport()) {
      return;
    }

    titleBlock = sectionRoot.querySelector('.product-block-list__item--mobile-title');
    galleryBlock = sectionRoot.querySelector('.product-block-list__item--gallery');
    infoBlock = sectionRoot.querySelector('.product-block-list__item--info');
    promotionBlock = sectionRoot.querySelector('.product-block-list__item--mobile-promotion');

    if (titleBlock) {
      titleBlock.style.order = '1';
      titleBlock.style.marginBottom = '0';
    }

    if (galleryBlock) {
      galleryBlock.style.order = '2';
      galleryBlock.style.marginBottom = '0';
    }

    if (infoBlock) {
      infoBlock.style.order = '3';
      infoBlock.style.marginBottom = '0';
    }

    toArray(sectionRoot.querySelectorAll('.product-block-list__item--description, .product-block-list__item--content, .product-block-list__item--reviews')).forEach(function(block) {
      block.style.order = '4';
    });

    if (promotionBlock) {
      promotionBlock.style.order = '5';
    }

    variantBlock = sectionRoot.querySelector('.product-info__block-item--variant-selector');

    if (!variantBlock) {
      return;
    }

    variantBlock.style.display = 'flex';
    variantBlock.style.flexDirection = 'column';
    variantBlock.style.gap = '12px';

    variantPicker = variantBlock.querySelector('.product-form__variants--static, variant-picker');
    infoList = variantBlock.querySelector('.product-form__info-list');
    pricingPanel = variantBlock.querySelector('.product-form__pricing-panel');

    if (variantPicker) {
      variantPicker.style.order = '1';
    }

    if (infoList) {
      infoList.style.order = '2';
      infoList.style.marginTop = '0';
    }

    if (pricingPanel) {
      pricingPanel.style.order = '3';
      pricingPanel.style.marginTop = '0';
    }
  }

  function revealSharedMedia(sectionRoot) {
    toArray(sectionRoot.querySelectorAll('.product-gallery__carousel-item, .product-gallery__thumbnail')).forEach(function(node) {
      if (isSharedMediaNode(node)) {
        removeFilterState(node);
      }
    });
  }

  function syncDesktopThumbnailRail(sectionRoot, visibleCount) {
    var wrapper = sectionRoot.querySelector('.product-gallery__thumbnail-list-wrapper');

    if (!wrapper) {
      return;
    }

    wrapper.classList.toggle('tuokus-thumbnail-list--compact', visibleCount <= 2);
  }

  function normalizeMobileGallery(sectionRoot, activeItem) {
    var gallery = sectionRoot.querySelector('.product-gallery');
    var wrapper = sectionRoot.querySelector('.product-gallery__carousel-wrapper');
    var carousel = sectionRoot.querySelector('.product-gallery__carousel');
    var viewport = carousel ? carousel.querySelector('.flickity-viewport') : null;
    var slider = carousel ? carousel.querySelector('.flickity-slider') : null;
    var thumbnailWrapper = sectionRoot.querySelector('.product-gallery__thumbnail-list-wrapper');
    var thumbnailList = sectionRoot.querySelector('.product-gallery__thumbnail-list');
    var scroller = sectionRoot.querySelector('.product-gallery > .scroller');
    var activeHeight = activeItem && activeItem.offsetHeight ? activeItem.offsetHeight : 0;

    if (!gallery || !isMobileViewport()) {
      return;
    }

    gallery.classList.remove('product-gallery--single-visible-media');
    gallery.classList.remove('product-gallery--few-visible-media');

    toArray([gallery, wrapper, carousel, viewport, slider, thumbnailWrapper, thumbnailList, scroller]).forEach(function(node) {
      if (!node) {
        return;
      }

      node.style.width = '100%';
      node.style.minWidth = '0';
      node.style.maxWidth = '100%';
      node.style.height = node === viewport && activeHeight ? activeHeight + 'px' : node.style.height;
    });

    toArray(sectionRoot.querySelectorAll('.product-gallery__carousel-item')).forEach(function(item) {
      item.style.width = '100%';
      item.style.minWidth = '100%';
      item.style.maxWidth = '100%';
    });

    toArray(sectionRoot.querySelectorAll('.product-gallery__size-limiter')).forEach(function(node) {
      node.style.width = '100%';
      node.style.maxWidth = '100%';
      node.style.minWidth = '0';
    });

    if (window.Flickity && carousel) {
      try {
        var flkty = window.Flickity.data(carousel);

        if (flkty) {
          flkty.resize();
        }
      } catch (error) {
      }
    }
  }

  function rememberRailScroll(trigger) {
    var rail = null;

    if (!trigger || !trigger.closest) {
      return;
    }

    rail = trigger.closest(VARIANT_RAIL_SELECTOR);

    if (!rail) {
      return;
    }

    rail.dataset.tuokusSavedScrollLeft = String(rail.scrollLeft || 0);
  }

  function revealRailItemWithinRail(rail, item) {
    var railRect = null;
    var itemRect = null;
    var padding = 10;

    if (!rail || !item || typeof rail.getBoundingClientRect !== 'function' || typeof item.getBoundingClientRect !== 'function') {
      return;
    }

    railRect = rail.getBoundingClientRect();
    itemRect = item.getBoundingClientRect();

    if (itemRect.left < railRect.left + padding) {
      rail.scrollLeft = Math.max(0, rail.scrollLeft + itemRect.left - railRect.left - padding);
    } else if (itemRect.right > railRect.right - padding) {
      rail.scrollLeft = Math.max(0, rail.scrollLeft + itemRect.right - railRect.right + padding);
    }
  }

  function restoreRailScroll(sectionRoot) {
    toArray(sectionRoot.querySelectorAll(VARIANT_RAIL_SELECTOR)).forEach(function(rail) {
      var selectedItem = rail.querySelector('.variant-swatch__item.is-selected, .block-swatch__item.is-selected, .color-swatch__item.is-selected');
      var savedScrollLeft = parseFloat(rail.dataset.tuokusSavedScrollLeft || '');

      if (!isNaN(savedScrollLeft)) {
        rail.scrollLeft = savedScrollLeft;
      }

      revealRailItemWithinRail(rail, selectedItem);
    });
  }

  function syncGallery(sectionRoot) {
    var gallery = null;
    var carousel = null;
    var carouselItems = [];
    var thumbnails = [];
    var visibleCarouselItems = [];
    var visibleThumbnails = [];
    var activeItem = null;
    var activeMediaId = '';
    var activeThumbnail = null;
    var visibleCount = 0;

    if (!sectionRoot || !sectionRoot.querySelectorAll) {
      return;
    }

    gallery = sectionRoot.querySelector('.product-gallery');
    carousel = sectionRoot.querySelector('.product-gallery__carousel');
    carouselItems = toArray(sectionRoot.querySelectorAll('.product-gallery__carousel-item'));
    thumbnails = toArray(sectionRoot.querySelectorAll('.product-gallery__thumbnail'));

    if (!gallery || !carouselItems.length) {
      return;
    }

    revealSharedMedia(sectionRoot);

    visibleCarouselItems = getVisibleNodes(carouselItems);
    visibleThumbnails = getVisibleNodes(thumbnails);

    if (!visibleCarouselItems.length) {
      removeFilterState(carouselItems[0]);
      visibleCarouselItems = getVisibleNodes(carouselItems);
    }

    activeItem =
      sectionRoot.querySelector('.product-gallery__carousel-item.is-selected:not(.is-filtered)') ||
      visibleCarouselItems[0] ||
      carouselItems[0] ||
      null;

    carouselItems.forEach(function(item) {
      item.classList.remove('is-selected');
    });

    if (activeItem) {
      removeFilterState(activeItem);
      activeItem.classList.add('is-selected');
      activeMediaId = activeItem.getAttribute('data-media-id') || '';
    }

    thumbnails.forEach(function(item) {
      item.classList.remove('is-nav-selected');
    });

    if (activeMediaId) {
      activeThumbnail = sectionRoot.querySelector('.product-gallery__thumbnail[data-media-id="' + activeMediaId + '"]');

      if (activeThumbnail) {
        removeFilterState(activeThumbnail);
        activeThumbnail.classList.add('is-nav-selected');
      }
    } else if (visibleThumbnails[0]) {
      visibleThumbnails[0].classList.add('is-nav-selected');
    }

    visibleCount = Math.max(getVisibleNodes(carouselItems).length, getVisibleNodes(thumbnails).length);
    gallery.setAttribute('data-visible-media-count', String(visibleCount));

    if (isMobileViewport()) {
      normalizeMobileGallery(sectionRoot, activeItem);
    } else {
      gallery.classList.toggle('product-gallery--single-visible-media', visibleCount <= 1);
      gallery.classList.toggle('product-gallery--few-visible-media', visibleCount > 1 && visibleCount <= 2);
      syncDesktopThumbnailRail(sectionRoot, visibleCount);
    }

    if (carousel && activeMediaId) {
      carousel.setAttribute('data-initial-media-id', activeMediaId);
    }

    restoreRailScroll(sectionRoot);
  }

  function markPromotionShells(root) {
    toArray(root.querySelectorAll('.product-gallery__promotion-shell--desktop-only, .product-block-list__item--mobile-promotion')).forEach(function(shell) {
      var cards = toArray(shell.querySelectorAll('.tuokus-promo-module__rail > *, .product-list > *, .product-item'));
      var hasVisibleCards = cards.some(function(card) {
        return card.offsetWidth > 0 || card.offsetHeight > 0;
      });

      shell.classList.toggle('tuokus-shell--empty', !hasVisibleCards);
    });
  }

  function bindDraggableRail(rail) {
    var pointerId = null;
    var startX = 0;
    var startScrollLeft = 0;
    var dragging = false;
    var suppressClick = false;

    if (!rail || rail.dataset.tuokusDragBound === 'true') {
      return;
    }

    rail.dataset.tuokusDragBound = 'true';
    rail.style.cursor = 'grab';

    rail.addEventListener('pointerdown', function(event) {
      if (event.pointerType === 'touch' || event.button !== 0) {
        return;
      }

      pointerId = event.pointerId;
      startX = event.clientX;
      startScrollLeft = rail.scrollLeft;
      dragging = false;
      suppressClick = false;

      if (typeof rail.setPointerCapture === 'function') {
        rail.setPointerCapture(pointerId);
      }

      rail.style.cursor = 'grabbing';
    });

    rail.addEventListener('pointermove', function(event) {
      var deltaX = 0;

      if (pointerId === null || event.pointerId !== pointerId) {
        return;
      }

      deltaX = event.clientX - startX;

      if (!dragging && Math.abs(deltaX) > 6) {
        dragging = true;
        suppressClick = true;
      }

      if (!dragging) {
        return;
      }

      rail.scrollLeft = startScrollLeft - deltaX;
      event.preventDefault();
    });

    function clearDrag() {
      if (pointerId !== null && typeof rail.releasePointerCapture === 'function' && rail.hasPointerCapture(pointerId)) {
        rail.releasePointerCapture(pointerId);
      }

      pointerId = null;
      dragging = false;
      rail.style.cursor = 'grab';

      window.setTimeout(function() {
        suppressClick = false;
      }, 0);
    }

    rail.addEventListener('pointerup', clearDrag);
    rail.addEventListener('pointercancel', clearDrag);
    rail.addEventListener('lostpointercapture', clearDrag);

    rail.addEventListener('click', function(event) {
      if (!suppressClick) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      suppressClick = false;
    }, true);
  }

  function bindRails(root) {
    toArray(root.querySelectorAll(RAIL_SELECTOR)).forEach(bindDraggableRail);
  }

  function copyWithTextarea(value) {
    var textarea = null;
    var copied = false;

    if (!value) {
      return false;
    }

    textarea = document.createElement('textarea');
    textarea.value = String(value);
    textarea.setAttribute('readonly', 'readonly');
    textarea.style.position = 'fixed';
    textarea.style.top = '-9999px';
    textarea.style.left = '-9999px';
    textarea.style.opacity = '0';

    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    textarea.setSelectionRange(0, textarea.value.length);

    try {
      copied = document.execCommand('copy');
    } catch (error) {
      copied = false;
    }

    document.body.removeChild(textarea);
    return copied;
  }

  function updateCouponButtonState(button, copied) {
    var label = button.querySelector('.product-form__coupon-copy-label');
    var defaultLabel = button.getAttribute('data-default-label') || 'コピー';
    var copiedLabel = button.getAttribute('data-copied-label') || 'コピー済み';

    button.classList.toggle('is-copied', copied);

    if (label) {
      label.textContent = copied ? copiedLabel : defaultLabel;
    }
  }

  function extractCouponCode(button) {
    var root = null;
    var codeNode = null;

    if (!button) {
      return '';
    }

    root = button.closest('[data-coupon-copy-root], .product-form__pricing-panel, .product-coupon-box');
    codeNode = root ? root.querySelector('[data-coupon-code], .product-form__coupon-code, .product-coupon-box__code') : null;

    return String(
      button.getAttribute('data-copy-value') ||
      button.getAttribute('data-coupon-code') ||
      button.getAttribute('data-copy-text') ||
      (codeNode ? (codeNode.getAttribute('data-coupon-code') || codeNode.textContent || '') : '')
    ).trim();
  }

  function copyCoupon(button) {
    var couponCode = extractCouponCode(button);
    var now = Date.now();
    var copiedSync = false;

    if (!couponCode) {
      return;
    }

    if (lastCopyState.button === button && now - lastCopyState.time < 500) {
      return;
    }

    lastCopyState.button = button;
    lastCopyState.time = now;

    copiedSync = copyWithTextarea(couponCode);

    if (copiedSync) {
      updateCouponButtonState(button, true);
      window.setTimeout(function() {
        updateCouponButtonState(button, false);
      }, 1800);
      return;
    }

    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
      navigator.clipboard.writeText(couponCode).then(function() {
        updateCouponButtonState(button, true);

        window.setTimeout(function() {
          updateCouponButtonState(button, false);
        }, 1800);
      }).catch(function() {
        updateCouponButtonState(button, copyWithTextarea(couponCode));

        window.setTimeout(function() {
          updateCouponButtonState(button, false);
        }, 1800);
      });
      return;
    }

    updateCouponButtonState(button, false);
  }

  function handleCouponCopy(event) {
    var button = event.target && event.target.closest ? event.target.closest(COUPON_BUTTON_SELECTOR) : null;

    if (!button) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    copyCoupon(button);
  }

  function reconcileProducts(root) {
    var scope = root && root.querySelectorAll ? root : document;

    bindRails(scope);
    markPromotionShells(scope);

    toArray(scope.querySelectorAll(PRODUCT_SECTION_SELECTOR)).forEach(function(sectionRoot) {
      forceProductBlockOrder(sectionRoot);
      syncGallery(sectionRoot);
      markPromotionShells(sectionRoot);
    });
  }

  function scheduleProductRecovery(sectionRoot) {
    if (!sectionRoot) {
      return;
    }

    [40, 120, 280, 540, 900].forEach(function(delay) {
      window.setTimeout(function() {
        forceProductBlockOrder(sectionRoot);
        syncGallery(sectionRoot);
        bindRails(sectionRoot);
        markPromotionShells(sectionRoot);
      }, delay);
    });
  }

  document.addEventListener('touchend', handleCouponCopy, true);
  document.addEventListener('click', handleCouponCopy, true);

  document.addEventListener('pointerdown', function(event) {
    var trigger = event.target && event.target.closest
      ? event.target.closest('.variant-swatch, .block-swatch, .color-swatch, .product-form__option-value')
      : null;

    if (trigger) {
      rememberRailScroll(trigger);
    }
  }, true);

  document.addEventListener('click', function(event) {
    var trigger = event.target && event.target.closest
      ? event.target.closest('.variant-swatch, .block-swatch, .color-swatch, .product-form__option-value')
      : null;
    var sectionRoot = getProductSection(trigger);

    if (!sectionRoot) {
      return;
    }

    scheduleProductRecovery(sectionRoot);
  }, true);

  document.addEventListener('change', function(event) {
    var trigger = event.target && event.target.closest
      ? event.target.closest('.product-form__single-selector[data-option-position], .product-form__option input, .product-form__option select')
      : null;
    var sectionRoot = getProductSection(trigger);

    if (!sectionRoot) {
      return;
    }

    scheduleProductRecovery(sectionRoot);
  }, true);

  document.addEventListener('variant:changed', function(event) {
    var sectionRoot = null;

    if (event.target && event.target.closest) {
      sectionRoot = event.target.closest(PRODUCT_SECTION_SELECTOR);
    }

    if (!sectionRoot && event.detail && event.detail.sectionId) {
      sectionRoot = document.querySelector(PRODUCT_SECTION_SELECTOR + '[data-section-id="' + event.detail.sectionId + '"]');
    }

    scheduleProductRecovery(sectionRoot);
  }, true);

  document.addEventListener('theme:loading:end', function(event) {
    window.requestAnimationFrame(function() {
      reconcileProducts(event.target || document);
    });
  });

  document.addEventListener('shopify:section:load', function(event) {
    window.requestAnimationFrame(function() {
      reconcileProducts(event.target || document);
    });
  });

  window.addEventListener('pageshow', function() {
    window.requestAnimationFrame(function() {
      reconcileProducts(document);
    });
  });

  window.addEventListener('resize', function() {
    window.requestAnimationFrame(function() {
      reconcileProducts(document);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      reconcileProducts(document);
    });
  } else {
    reconcileProducts(document);
  }
})();

(function() {
  if (window.__TUOKUS_FINAL_RECOVERY_ACTIVE) {
    return;
  }

  var PRODUCT_SECTION_SELECTOR = '[data-section-type="product"]';
  var COPY_BUTTON_SELECTOR = '[data-copy-coupon], [data-coupon-copy-button]';

  function toArray(nodes) {
    return Array.prototype.slice.call(nodes || []);
  }

  function normalizeValue(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function parseVariantIds(csv) {
    return String(csv || '')
      .split(',')
      .map(function(value) {
        return String(value || '').trim();
      })
      .filter(Boolean);
  }

  function getCurrentVariantId(sectionRoot) {
    var variantInput = null;

    if (!sectionRoot) {
      return '';
    }

    variantInput =
      sectionRoot.querySelector('form[action*="/cart/add"] input[name="id"]') ||
      sectionRoot.querySelector('input[name="id"][data-sku]') ||
      null;

    return variantInput ? String(variantInput.value || '').trim() : '';
  }

  function getSelectedOptionMap(sectionRoot) {
    var optionMap = {};

    if (!sectionRoot) {
      return optionMap;
    }

    toArray(sectionRoot.querySelectorAll('.product-form__option')).forEach(function(optionElement) {
      var optionNameNode = optionElement.querySelector('.product-form__option-name');
      var selectedValueNode = optionElement.querySelector('.product-form__selected-value');
      var checkedInput = optionElement.querySelector('input:checked');
      var selectedSelect = optionElement.querySelector('select');
      var optionName = '';
      var selectedValue = '';
      var selectedLabel = null;

      if (optionNameNode) {
        optionName = normalizeValue(optionNameNode.textContent.split(':')[0]);
      }

      if (selectedValueNode && selectedValueNode.textContent.trim()) {
        selectedValue = normalizeValue(selectedValueNode.textContent);
      }

      if (!selectedValue && checkedInput) {
        selectedLabel = optionElement.querySelector('label[for="' + checkedInput.id + '"]');

        if (selectedLabel) {
          selectedValue = normalizeValue(
            selectedLabel.getAttribute('data-raw-value') ||
            selectedLabel.getAttribute('data-display-value') ||
            selectedLabel.textContent
          );
        }
      }

      if (!selectedValue && selectedSelect && selectedSelect.selectedIndex >= 0) {
        selectedValue = normalizeValue(
          selectedSelect.options[selectedSelect.selectedIndex].getAttribute('data-display-value') ||
          selectedSelect.options[selectedSelect.selectedIndex].textContent
        );
      }

      if (!optionName || !selectedValue) {
        return;
      }

      optionMap[optionName] = selectedValue;

      if (optionName === 'カラー' || optionName === '色' || optionName === 'color' || optionName === 'colour') {
        optionMap.color = selectedValue;
      }

      if (optionName === '柄' || optionName === 'pattern' || optionName === 'design' || optionName === 'style') {
        optionMap.pattern = selectedValue;
      }
    });

    return optionMap;
  }

  function itemMatchesSelection(item, variantId, optionMap) {
    var variantIds = parseVariantIds(item.getAttribute('data-variant-ids'));
    var groupName = normalizeValue(item.getAttribute('data-group-name'));
    var groupValue = normalizeValue(item.getAttribute('data-group-value'));
    var selectedGroupValue = '';

    if (variantIds.length) {
      return variantIds.indexOf(variantId) !== -1;
    }

    if (groupName && groupValue) {
      selectedGroupValue = optionMap[groupName] || optionMap.color || optionMap.pattern || '';

      if (!selectedGroupValue) {
        return true;
      }

      return selectedGroupValue === groupValue;
    }

    return true;
  }

  function syncGalleryForSection(sectionRoot) {
    var gallery = null;
    var carousel = null;
    var carouselItems = [];
    var thumbnails = [];
    var optionMap = {};
    var variantId = '';
    var visibleItems = [];
    var preferredHero = null;
    var selectedHero = null;
    var selectedMediaId = '';
    var thumbnailTarget = null;
    var visibleCount = 0;

    if (!sectionRoot || !sectionRoot.querySelectorAll) {
      return;
    }

    gallery = sectionRoot.querySelector('.product-gallery');
    carousel = sectionRoot.querySelector('.product-gallery__carousel');
    carouselItems = toArray(sectionRoot.querySelectorAll('.product-gallery__carousel-item'));
    thumbnails = toArray(sectionRoot.querySelectorAll('.product-gallery__thumbnail'));

    if (!gallery || !carouselItems.length) {
      return;
    }

    variantId = getCurrentVariantId(sectionRoot);
    optionMap = getSelectedOptionMap(sectionRoot);

    carouselItems.forEach(function(item) {
      var mediaId = item.getAttribute('data-media-id') || '';
      var visible = itemMatchesSelection(item, variantId, optionMap);
      var linkedThumbnail = mediaId
        ? sectionRoot.querySelector('.product-gallery__thumbnail[data-media-id="' + mediaId + '"]')
        : null;

      item.classList.toggle('is-filtered', !visible);
      item.removeAttribute('data-tuokus-shared-detail-active');

      if (linkedThumbnail) {
        linkedThumbnail.classList.toggle('is-filtered', !visible);
      }
    });

    visibleItems = carouselItems.filter(function(item) {
      return !item.classList.contains('is-filtered');
    });

    if (!visibleItems.length) {
      carouselItems.forEach(function(item) {
        var mediaId = item.getAttribute('data-media-id') || '';
        var linkedThumbnail = mediaId
          ? sectionRoot.querySelector('.product-gallery__thumbnail[data-media-id="' + mediaId + '"]')
          : null;

        item.classList.remove('is-filtered');

        if (linkedThumbnail) {
          linkedThumbnail.classList.remove('is-filtered');
        }
      });

      visibleItems = carouselItems.slice();
    }

    preferredHero = visibleItems.find(function(item) {
      return parseVariantIds(item.getAttribute('data-variant-ids')).indexOf(variantId) !== -1;
    }) || visibleItems[0] || null;

    selectedHero =
      sectionRoot.querySelector('.product-gallery__carousel-item.is-selected:not(.is-filtered)') ||
      preferredHero;

    if (selectedHero && parseVariantIds(selectedHero.getAttribute('data-variant-ids')).indexOf(variantId) === -1) {
      selectedHero = preferredHero;
    }

    carouselItems.forEach(function(item) {
      item.classList.toggle('is-selected', item === selectedHero);
    });

    selectedMediaId = selectedHero ? (selectedHero.getAttribute('data-media-id') || '') : '';

    thumbnails.forEach(function(item) {
      item.classList.remove('is-nav-selected');
    });

    thumbnailTarget = selectedMediaId
      ? sectionRoot.querySelector('.product-gallery__thumbnail[data-media-id="' + selectedMediaId + '"]:not(.is-filtered)')
      : null;

    if (!thumbnailTarget) {
      thumbnailTarget = thumbnails.find(function(item) {
        return !item.classList.contains('is-filtered');
      }) || null;
    }

    if (thumbnailTarget) {
      thumbnailTarget.classList.add('is-nav-selected');
    }

    visibleCount = visibleItems.length;
    gallery.classList.toggle('product-gallery--single-visible-media', visibleCount <= 1);
    gallery.classList.toggle('product-gallery--few-visible-media', visibleCount > 1 && visibleCount <= 2);
    gallery.setAttribute('data-visible-media-count', String(visibleCount));

    if (carousel && selectedMediaId) {
      carousel.setAttribute('data-initial-media-id', selectedMediaId);
    }
  }

  function scheduleGallerySync(sectionRoot) {
    if (!sectionRoot) {
      return;
    }

    [40, 180, 420].forEach(function(delay) {
      window.setTimeout(function() {
        syncGalleryForSection(sectionRoot);
      }, delay);
    });
  }

  function syncAllProductSections(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll(PRODUCT_SECTION_SELECTOR).forEach(function(sectionRoot) {
      syncGalleryForSection(sectionRoot);
    });
  }

  function tryLegacyCopy(text) {
    var textarea = document.createElement('textarea');
    var copied = false;

    textarea.value = text;
    textarea.setAttribute('readonly', 'readonly');
    textarea.style.position = 'fixed';
    textarea.style.top = '-9999px';
    textarea.style.left = '-9999px';
    textarea.style.opacity = '0';

    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    textarea.setSelectionRange(0, textarea.value.length);

    try {
      copied = document.execCommand('copy');
    } catch (error) {
      copied = false;
    }

    document.body.removeChild(textarea);

    return copied;
  }

  function setCopyState(button, copied) {
    var label = button.querySelector('.product-form__coupon-copy-label');
    var defaultLabel = button.getAttribute('data-default-label') || 'コピー';
    var copiedLabel = button.getAttribute('data-copied-label') || 'コピー済み';

    button.classList.toggle('is-copied', copied);

    if (label) {
      label.textContent = copied ? copiedLabel : defaultLabel;
    }
  }

  function resolveCouponCode(button) {
    var root = null;
    var codeNode = null;

    if (!button) {
      return '';
    }

    root = button.closest('.product-form__pricing-panel, .product-coupon-box, [data-coupon-copy-root]');
    codeNode = root
      ? root.querySelector('[data-coupon-code], .product-form__coupon-code, .product-coupon-box__code')
      : null;

    return normalizeValue(
      button.getAttribute('data-copy-value') ||
      button.getAttribute('data-coupon-code') ||
      button.getAttribute('data-copy-text') ||
      (codeNode ? (codeNode.getAttribute('data-coupon-code') || codeNode.textContent || '') : '')
    ).toUpperCase();
  }

  function copyCouponCode(button) {
    var couponCode = resolveCouponCode(button);

    if (!couponCode) {
      return;
    }

    if (tryLegacyCopy(couponCode)) {
      setCopyState(button, true);

      window.setTimeout(function() {
        setCopyState(button, false);
      }, 1800);

      return;
    }

    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function' && window.isSecureContext) {
      navigator.clipboard.writeText(couponCode).then(function() {
        setCopyState(button, true);

        window.setTimeout(function() {
          setCopyState(button, false);
        }, 1800);
      }).catch(function() {
        setCopyState(button, false);
      });

      return;
    }

    setCopyState(button, false);
  }

  document.addEventListener('click', function(event) {
    var button = event.target && event.target.closest ? event.target.closest(COPY_BUTTON_SELECTOR) : null;

    if (!button) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    copyCouponCode(button);
  }, true);

  document.addEventListener('click', function(event) {
    var trigger = event.target && event.target.closest
      ? event.target.closest('.variant-swatch, .block-swatch, .color-swatch, .product-form__option-value')
      : null;
    var sectionRoot = trigger && trigger.closest ? trigger.closest(PRODUCT_SECTION_SELECTOR) : null;

    if (sectionRoot) {
      scheduleGallerySync(sectionRoot);
    }
  }, true);

  document.addEventListener('change', function(event) {
    var trigger = event.target && event.target.closest
      ? event.target.closest('.product-form__single-selector, .product-form__option select')
      : null;
    var sectionRoot = trigger && trigger.closest ? trigger.closest(PRODUCT_SECTION_SELECTOR) : null;

    if (sectionRoot) {
      scheduleGallerySync(sectionRoot);
    }
  }, true);

  document.addEventListener('variant:changed', function(event) {
    var sectionRoot = event.target && event.target.closest ? event.target.closest(PRODUCT_SECTION_SELECTOR) : null;

    if (!sectionRoot && event.detail && event.detail.sectionId) {
      sectionRoot = document.querySelector(PRODUCT_SECTION_SELECTOR + '[data-section-id="' + event.detail.sectionId + '"]');
    }

    scheduleGallerySync(sectionRoot);
  }, true);

  document.addEventListener('theme:loading:end', function(event) {
    window.requestAnimationFrame(function() {
      syncAllProductSections(event.target || document);
    });
  });

  document.addEventListener('shopify:section:load', function(event) {
    window.requestAnimationFrame(function() {
      syncAllProductSections(event.target || document);
    });
  });

  window.addEventListener('pageshow', function() {
    window.requestAnimationFrame(function() {
      syncAllProductSections(document);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      syncAllProductSections(document);
    });
  } else {
    syncAllProductSections(document);
  }
})();

  /* Legacy duplicate product copy/gallery reconcilers removed in favor of the final product reconciler near the end of this file.
(function() {
  if (window.__TUOKUS_FINAL_RECOVERY_ACTIVE) {
    return;
  }

  var PRODUCT_SECTION_SELECTOR = '[data-section-type="product"]';
  var SUPPORT_TITLES = [
    '\u30b5\u30a4\u30ba\u306b\u3064\u3044\u3066',
    '\u304a\u624b\u5165\u308c\u65b9\u6cd5',
    '\u914d\u9001\u30fb\u8fd4\u54c1\u306b\u3064\u3044\u3066'
  ];
  var MOJIBAKE_PATTERN = /閸熷棗鎼閵夘兙鍎瀨闁板秹|鏉╂柨鎼閵堢偣鍋唡[\uFFFD]/;
  var REFUND_MARKUP = [
    '<h2>\u914d\u9001\u30fb\u8fd4\u54c1\u30dd\u30ea\u30b7\u30fc\u306b\u3064\u3044\u3066</h2>',
    '<p>\u65e5\u672c\u3078\u306e\u304a\u5c4a\u3051\u76ee\u5b89\u306f\u901a\u5e388\u301c11\u65e5\u3067\u3059\u3002\u5730\u57df\u3084\u914d\u9001\u72b6\u6cc1\u306b\u3088\u308a\u524d\u5f8c\u3059\u308b\u5834\u5408\u304c\u3042\u308a\u307e\u3059\u306e\u3067\u3001\u3042\u3089\u304b\u3058\u3081\u3054\u4e86\u627f\u304f\u3060\u3055\u3044\u3002</p>',
    '<h3>\u8fd4\u54c1\u306b\u3064\u3044\u3066</h3>',
    '<p>\u5546\u54c1\u306b\u4e0d\u5177\u5408\u3084\u7834\u640d\u304c\u3042\u3063\u305f\u5834\u5408\u306f\u3001\u5546\u54c1\u5230\u7740\u5f8c\u3067\u304d\u308b\u3060\u3051\u65e9\u304f\u3054\u9023\u7d61\u304f\u3060\u3055\u3044\u3002\u5185\u5bb9\u3092\u78ba\u8a8d\u306e\u3046\u3048\u3001\u4ea4\u63db\u307e\u305f\u306f\u8fd4\u54c1\u306e\u6d41\u308c\u3092\u3054\u6848\u5185\u3044\u305f\u3057\u307e\u3059\u3002</p>',
    '<h3>\u3054\u78ba\u8a8d\u4e8b\u9805</h3>',
    '<p>\u3054\u4f7f\u7528\u5f8c\u306e\u6c5a\u308c\u3084\u304a\u5ba2\u69d8\u90fd\u5408\u3067\u306e\u8fd4\u54c1\u6761\u4ef6\u306a\u3069\u3001\u8a73\u3057\u304f\u306f\u30b9\u30c8\u30a2\u306e\u914d\u9001\u30fb\u8fd4\u54c1\u30dd\u30ea\u30b7\u30fc\u3092\u3054\u78ba\u8a8d\u304f\u3060\u3055\u3044\u3002</p>'
  ].join('');

  function syncVisibleProductGallery(sectionRoot) {
    var gallery = null;
    var visibleCarouselItems = [];
    var visibleThumbnails = [];
    var activeCarouselItem = null;
    var activeThumbnail = null;
    var activeMediaId = '';
    var visibleCount = 0;
    var carousel = null;

    if (!sectionRoot || !sectionRoot.querySelector) {
      return;
    }

    gallery = sectionRoot.querySelector('.product-gallery');

    if (!gallery) {
      return;
    }

    visibleCarouselItems = Array.prototype.slice.call(
      sectionRoot.querySelectorAll('.product-gallery__carousel-item:not(.is-filtered)')
    );
    visibleThumbnails = Array.prototype.slice.call(
      sectionRoot.querySelectorAll('.product-gallery__thumbnail:not(.is-filtered)')
    );
    activeCarouselItem =
      sectionRoot.querySelector('.product-gallery__carousel-item.is-selected:not(.is-filtered)') ||
      visibleCarouselItems[0] ||
      null;

    sectionRoot.querySelectorAll('.product-gallery__carousel-item.is-selected').forEach(function(item) {
      item.classList.remove('is-selected');
    });

    if (activeCarouselItem) {
      activeCarouselItem.classList.add('is-selected');
      activeMediaId = activeCarouselItem.getAttribute('data-media-id') || '';
    }

    sectionRoot.querySelectorAll('.product-gallery__thumbnail.is-nav-selected').forEach(function(item) {
      item.classList.remove('is-nav-selected');
    });

    activeThumbnail = activeMediaId
      ? sectionRoot.querySelector('.product-gallery__thumbnail[data-media-id="' + activeMediaId + '"]:not(.is-filtered)')
      : (visibleThumbnails[0] || null);

    if (activeThumbnail) {
      activeThumbnail.classList.add('is-nav-selected');
    }

    visibleCount = visibleThumbnails.length || visibleCarouselItems.length;
    gallery.classList.toggle('product-gallery--single-visible-media', visibleCount <= 1);
    gallery.classList.toggle('product-gallery--few-visible-media', visibleCount > 1 && visibleCount <= 2);
    gallery.setAttribute('data-visible-media-count', String(visibleCount));

    if (activeMediaId) {
      carousel = sectionRoot.querySelector('.product-gallery__carousel');

      if (carousel) {
        carousel.setAttribute('data-initial-media-id', activeMediaId);
      }
    }
  }

  function stripBorrowedSharedDetailMedia(sectionRoot) {
    if (!sectionRoot || !sectionRoot.querySelectorAll) {
      return;
    }

    syncVisibleProductGallery(sectionRoot);
  }

  function normalizeProductJapaneseCopy(sectionRoot) {
    if (!sectionRoot || !sectionRoot.querySelectorAll) {
      return;
    }

    sectionRoot.querySelectorAll('.product-block-list__item--content .card__title').forEach(function(title, index) {
      if (index >= SUPPORT_TITLES.length) {
        return;
      }

      title.textContent = SUPPORT_TITLES[index];
    });

    sectionRoot.querySelectorAll('.product-block-list__item--description .card__title').forEach(function(title) {
      title.textContent = '\u5546\u54c1\u8a73\u7d30';
    });

    sectionRoot.querySelectorAll('.product-block-list__item--reviews .card__title').forEach(function(title) {
      title.textContent = '\u30ec\u30d3\u30e5\u30fc';
    });

    sectionRoot.querySelectorAll('#modal-refunds-policy .rte').forEach(function(content) {
      var text = (content.textContent || '').trim();

      if (!text || MOJIBAKE_PATTERN.test(text)) {
        content.innerHTML = REFUND_MARKUP;
      }
    });
  }

  function reconcileProductSection(sectionRoot) {
    normalizeProductJapaneseCopy(sectionRoot);
    stripBorrowedSharedDetailMedia(sectionRoot);
  }

  function reconcileProductSections(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll(PRODUCT_SECTION_SELECTOR).forEach(function(sectionRoot) {
      reconcileProductSection(sectionRoot);
    });
  }

  document.addEventListener('theme:loading:end', function(event) {
    window.requestAnimationFrame(function() {
      reconcileProductSections(event.target || document);
    });
  });

  document.addEventListener('shopify:section:load', function(event) {
    window.requestAnimationFrame(function() {
      reconcileProductSections(event.target || document);
    });
  });

  document.addEventListener('change', function(event) {
    var optionInput = event.target.closest && event.target.closest('.product-form__single-selector[data-option-position]');
    var sectionRoot = null;

    if (!optionInput) {
      return;
    }

    sectionRoot = optionInput.closest(PRODUCT_SECTION_SELECTOR);

    if (!sectionRoot) {
      return;
    }

    window.setTimeout(function() {
      reconcileProductSection(sectionRoot);
    }, 32);
  }, true);

  window.addEventListener('pageshow', function() {
    window.requestAnimationFrame(function() {
      reconcileProductSections(document);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      reconcileProductSections(document);
    });
  } else {
    reconcileProductSections(document);
  }
})();

(function() {
  if (window.__TUOKUS_FINAL_RECOVERY_ACTIVE) {
    return;
  }

  var PRODUCT_SECTION_SELECTOR = '[data-section-type="product"]';
  var SUPPORT_TITLES = ['サイズについて', 'お手入れ方法', '配送・返品について'];
  var MOJIBAKE_PATTERN = /[\uFFFD]|(?:閵噟閵坾閵墊闂亅闁皘閸焲鏉﹟鐟瓅閺墊闁竱濡?/;
  var REFUND_MARKUP = [
    '<h2>配送・返品ポリシーについて</h2>',
    '<p>日本へのお届け目安は通常8〜11日です。地域や配送状況により前後する場合がありますので、あらかじめご了承ください。</p>',
    '<h3>返品について</h3>',
    '<p>商品に不具合や破損があった場合は、商品到着後できるだけ早くご連絡ください。内容を確認のうえ、交換または返品の流れをご案内いたします。</p>',
    '<h3>ご確認事項</h3>',
    '<p>ご使用後の汚れやお客様都合での返品条件など、詳しくはストアの配送・返品ポリシーをご確認ください。</p>'
  ].join('');

  function syncVisibleProductGallery(sectionRoot) {
    var gallery = null;
    var visibleCarouselItems = [];
    var visibleThumbnails = [];
    var activeCarouselItem = null;
    var activeThumbnail = null;
    var activeMediaId = '';
    var visibleCount = 0;

    if (!sectionRoot || !sectionRoot.querySelector) {
      return;
    }

    gallery = sectionRoot.querySelector('.product-gallery');

    if (!gallery) {
      return;
    }

    visibleCarouselItems = Array.prototype.slice.call(sectionRoot.querySelectorAll('.product-gallery__carousel-item:not(.is-filtered)'));
    visibleThumbnails = Array.prototype.slice.call(sectionRoot.querySelectorAll('.product-gallery__thumbnail:not(.is-filtered)'));
    activeCarouselItem = sectionRoot.querySelector('.product-gallery__carousel-item.is-selected:not(.is-filtered)') || visibleCarouselItems[0] || null;

    sectionRoot.querySelectorAll('.product-gallery__carousel-item.is-selected').forEach(function(item) {
      item.classList.remove('is-selected');
    });

    if (activeCarouselItem) {
      activeCarouselItem.classList.add('is-selected');
      activeMediaId = activeCarouselItem.getAttribute('data-media-id') || '';
    }

    sectionRoot.querySelectorAll('.product-gallery__thumbnail.is-nav-selected').forEach(function(item) {
      item.classList.remove('is-nav-selected');
    });

    activeThumbnail = activeMediaId
      ? sectionRoot.querySelector('.product-gallery__thumbnail[data-media-id="' + activeMediaId + '"]:not(.is-filtered)')
      : (visibleThumbnails[0] || null);

    if (activeThumbnail) {
      activeThumbnail.classList.add('is-nav-selected');
    }

    visibleCount = visibleThumbnails.length || visibleCarouselItems.length;
    gallery.classList.toggle('product-gallery--single-visible-media', visibleCount <= 1);
    gallery.classList.toggle('product-gallery--few-visible-media', visibleCount > 1 && visibleCount <= 2);
    gallery.setAttribute('data-visible-media-count', String(visibleCount));

    if (activeMediaId) {
      var carousel = sectionRoot.querySelector('.product-gallery__carousel');

      if (carousel) {
        carousel.setAttribute('data-initial-media-id', activeMediaId);
      }
    }
  }

  function stripBorrowedSharedDetailMedia(sectionRoot) {
    if (!sectionRoot || !sectionRoot.querySelectorAll) {
      return;
    }

    syncVisibleProductGallery(sectionRoot);
  }

  function normalizeProductJapaneseCopy(sectionRoot) {
    if (!sectionRoot || !sectionRoot.querySelectorAll) {
      return;
    }

    sectionRoot.querySelectorAll('.product-block-list__item--content .card__title').forEach(function(title, index) {
      if (index >= SUPPORT_TITLES.length) {
        return;
      }

      title.textContent = SUPPORT_TITLES[index];
    });

    sectionRoot.querySelectorAll('.product-block-list__item--description .card__title').forEach(function(title) {
      title.textContent = '\u5546\u54c1\u8a73\u7d30';
    });

    sectionRoot.querySelectorAll('.product-block-list__item--reviews .card__title').forEach(function(title) {
      title.textContent = '\u30ec\u30d3\u30e5\u30fc';
    });

    sectionRoot.querySelectorAll('#modal-refunds-policy .rte').forEach(function(content) {
      var text = (content.textContent || '').trim();

      if (!text || MOJIBAKE_PATTERN.test(text)) {
        content.innerHTML = REFUND_MARKUP;
      }
    });
  }

  function reconcileProductSection(sectionRoot) {
    normalizeProductJapaneseCopy(sectionRoot);
    stripBorrowedSharedDetailMedia(sectionRoot);
  }

  function reconcileProductSections(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll(PRODUCT_SECTION_SELECTOR).forEach(function(sectionRoot) {
      reconcileProductSection(sectionRoot);
    });
  }

  document.addEventListener('theme:loading:end', function(event) {
    window.requestAnimationFrame(function() {
      reconcileProductSections(event.target || document);
    });
  });

  document.addEventListener('shopify:section:load', function(event) {
    window.requestAnimationFrame(function() {
      reconcileProductSections(event.target || document);
    });
  });

  document.addEventListener('change', function(event) {
    var optionInput = event.target.closest && event.target.closest('.product-form__single-selector[data-option-position]');
    var sectionRoot = null;

    if (!optionInput) {
      return;
    }

    sectionRoot = optionInput.closest(PRODUCT_SECTION_SELECTOR);

    if (!sectionRoot) {
      return;
    }

    window.setTimeout(function() {
      reconcileProductSection(sectionRoot);
    }, 32);
  }, true);

  window.addEventListener('pageshow', function() {
    window.requestAnimationFrame(function() {
      reconcileProductSections(document);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      reconcileProductSections(document);
    });
  } else {
    reconcileProductSections(document);
  }
})();

(function() {
  if (window.__TUOKUS_FINAL_RECOVERY_ACTIVE) {
    return;
  }

  var supportTitles = ['銈点偆銈恒伀銇ゃ亜銇?, '銇婃墜鍏ャ倢鏂规硶', '閰嶉€併兓杩斿搧銇仱銇勩仸'];
  var refundMarkup = [
    '<h2>閰嶉€併兓杩斿搧銉濄儶銈枫兗銇仱銇勩仸</h2>',
    '<p>鏃ユ湰銇搞伄銇婂眾銇戠洰瀹夈伅 8銆?1 鏃ャ仹銇欍€傝┏銇椼亸銇厤閫併儩銉偡銉笺仺杩斿搧銉濄儶銈枫兗銈掋仈纰鸿獚銇忋仩銇曘亜銆?/p>',
    '<h3>杩斿搧銇仱銇勩仸</h3>',
    '<p>鏈娇鐢ㄣ亱銇ゅ埌鐫€寰屻伄鐩歌珖鏈熼枔鍐呫仹銇傘倢銇般€佺姸鎱嬬⒑瑾嶃伄涓娿仹杩斿搧銉讳氦鎻涖倰銇旀鍐呫亜銇熴仐銇俱仚銆?/p>',
    '<h3>銇旂⒑瑾嶄簨闋?/h3>',
    '<p>瑭崇窗銇潯浠躲倓瀵惧繙鎵嬮爢銇€併偣銉堛偄銉濄儶銈枫兗銇部銇ｃ仸銇旀鍐呫亜銇熴仐銇俱仚銆?/p>'
  ].join('');
  var mojibakePattern = /[\uFFFD]|[閵堥妵闁伴崯鏉╅妷閸愮懎]/;

  function normalizeFinalProductJapaneseCopy(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('[data-section-type="product"]').forEach(function(sectionRoot) {
      sectionRoot.querySelectorAll('.product-block-list__item--description .card__title').forEach(function(title) {
        title.textContent = '鍟嗗搧瑭崇窗';
      });

      sectionRoot.querySelectorAll('.product-block-list__item--content .card__title').forEach(function(title, index) {
        if (index < supportTitles.length) {
          title.textContent = supportTitles[index];
        }
      });

      sectionRoot.querySelectorAll('.product-block-list__item--reviews .card__title').forEach(function(title) {
        title.textContent = '銉儞銉ャ兗';
      });

      sectionRoot.querySelectorAll('#modal-refunds-policy .rte').forEach(function(content) {
        var text = (content.textContent || '').trim();

        if (!text || mojibakePattern.test(text)) {
          content.innerHTML = refundMarkup;
        }
      });
    });
  }

  document.addEventListener('theme:loading:end', function(event) {
    normalizeFinalProductJapaneseCopy(event.target || document);
  });

  document.addEventListener('shopify:section:load', function(event) {
    normalizeFinalProductJapaneseCopy(event.target || document);
  });

  window.addEventListener('pageshow', function() {
    normalizeFinalProductJapaneseCopy(document);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      normalizeFinalProductJapaneseCopy(document);
    });
  } else {
    normalizeFinalProductJapaneseCopy(document);
  }
})();

(function() {
  if (window.__TUOKUS_FINAL_RECOVERY_ACTIVE) {
    return;
  }

  var supportTitles = ['銈点偆銈恒伀銇ゃ亜銇?, '銇婃墜鍏ャ倢鏂规硶', '閰嶉€併兓杩斿搧銇仱銇勩仸'];
  var mojibakePattern = /[\uFFFD]|(?:閵噟閵坾閵墊闂亅闁皘鏉?/;
  var refundMarkup = [
    '<h2>閰嶉€併兓杩斿搧銉濄儶銈枫兗銇仱銇勩仸</h2>',
    '<p>鏃ユ湰銇搞伄銇婂眾銇戠洰瀹夈伅閫氬父8銆?1鏃ャ仹銇欍€傚湴鍩熴倓閰嶉€佺姸娉併伀銈堛倞鍓嶅緦銇欍倠鍫村悎銇屻亗銈娿伨銇欍伄銇с€併亗銈夈亱銇樸倎銇斾簡鎵裤亸銇犮仌銇勩€?/p>',
    '<h3>杩斿搧銇仱銇勩仸</h3>',
    '<p>鍟嗗搧銇笉鍏峰悎銈勭牬鎼嶃亴銇傘仯銇熷牬鍚堛伅銆佸晢鍝佸埌鐫€寰屻仹銇嶃倠銇犮亼鏃┿亸銇旈€ｇ怠銇忋仩銇曘亜銆傚唴瀹广倰纰鸿獚銇亞銇堛€佷氦鎻涖伨銇熴伅杩斿搧銇祦銈屻倰銇旀鍐呫亜銇熴仐銇俱仚銆?/p>',
    '<h3>銇旂⒑瑾嶄簨闋?/h3>',
    '<p>銇斾娇鐢ㄥ緦銇睔銈屻倓銇婂銇曘伨閮藉悎銇с伄杩斿搧鏉′欢銇仼銆佽┏绱般伅銈广儓銈伄閰嶉€併兓杩斿搧銉濄儶銈枫兗銈掋仈纰鸿獚銇忋仩銇曘亜銆?/p>'
  ].join('');

  function normalizeProductSupportCopyFinal(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('[data-section-type="product"]').forEach(function(sectionRoot) {
      sectionRoot.querySelectorAll('.product-block-list__item--content .card__title').forEach(function(title, index) {
        if (index >= supportTitles.length) {
          return;
        }

        title.textContent = supportTitles[index];
      });

      sectionRoot.querySelectorAll('.product-block-list__item--description .card__title').forEach(function(title) {
        title.textContent = '鍟嗗搧瑭崇窗';
      });

      sectionRoot.querySelectorAll('.product-block-list__item--reviews .card__title').forEach(function(title) {
        title.textContent = '銉儞銉ャ兗';
      });

      sectionRoot.querySelectorAll('#modal-refunds-policy .rte').forEach(function(content) {
        var text = (content.textContent || '').trim();

        if (!text || mojibakePattern.test(text)) {
          content.innerHTML = refundMarkup;
        }
      });
    });
  }

  document.addEventListener('theme:loading:end', function(event) {
    normalizeProductSupportCopyFinal(event.target || document);
  });

  document.addEventListener('shopify:section:load', function(event) {
    normalizeProductSupportCopyFinal(event.target || document);
  });

  window.addEventListener('pageshow', function() {
    normalizeProductSupportCopyFinal(document);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      normalizeProductSupportCopyFinal(document);
    });
  } else {
    normalizeProductSupportCopyFinal(document);
  }
})();
  */

(function() {
  var tuokusTheme = window.TuokusTheme = window.TuokusTheme || {};
  var TRACK_SELECTOR = '.color-swatch-list--large, .block-swatch-list, .variant-swatch-list';

  function syncAttributes(currentElement, nextElement) {
    if (!currentElement || !nextElement) {
      return;
    }

    Array.from(currentElement.attributes).forEach(function(attribute) {
      if (!nextElement.hasAttribute(attribute.name)) {
        currentElement.removeAttribute(attribute.name);
      }
    });

    Array.from(nextElement.attributes).forEach(function(attribute) {
      currentElement.setAttribute(attribute.name, attribute.value);
    });
  }

  function isMobileViewport() {
    return window.matchMedia ? window.matchMedia('(max-width: 999px)').matches : window.innerWidth <= 999;
  }

  function syncButtonState(currentButton, nextButton) {
    if (!currentButton || !nextButton) {
      return false;
    }

    syncAttributes(currentButton, nextButton);
    if (currentButton.innerHTML !== nextButton.innerHTML) {
      currentButton.innerHTML = nextButton.innerHTML;
    }
    currentButton.disabled = nextButton.disabled;

    return true;
  }

  function syncMobilePaymentState(currentBlock, nextBlock) {
    var currentWrapper = currentBlock ? currentBlock.querySelector('.product-form__buy-buttons') : null;
    var nextWrapper = nextBlock ? nextBlock.querySelector('.product-form__buy-buttons') : null;
    var currentContainer = currentWrapper ? currentWrapper.querySelector('.product-form__payment-container') : null;
    var nextContainer = nextWrapper ? nextWrapper.querySelector('.product-form__payment-container') : null;
    var currentPaymentButton = currentContainer ? currentContainer.querySelector('.shopify-payment-button') : null;
    var nextPaymentButton = nextContainer ? nextContainer.querySelector('.shopify-payment-button') : null;
    var currentBuyElement = currentContainer ? currentContainer.querySelector('buy-button') : null;
    var nextBuyElement = nextContainer ? nextContainer.querySelector('buy-button') : null;
    var paymentHeight = 0;

    if (!currentWrapper || !nextWrapper || !currentContainer || !nextContainer) {
      return false;
    }

    paymentHeight = Math.ceil(currentContainer.getBoundingClientRect().height || 0);
    if (paymentHeight > 0) {
      currentWrapper.style.setProperty('--tuokus-payment-stable-height', paymentHeight + 'px');
    }

    currentWrapper.classList.add('is-tuokus-payment-stabilized');
    currentWrapper.classList.remove('has-mobile-sticky-spacer');
    currentContainer.classList.remove('is-mobile-sticky');

    syncAttributes(currentContainer, nextContainer);
    currentContainer.classList.remove('is-mobile-sticky');

    if (currentBuyElement && nextBuyElement) {
      syncAttributes(currentBuyElement, nextBuyElement);
    }

    syncButtonState(
      currentContainer.querySelector('.product-form__add-button'),
      nextContainer.querySelector('.product-form__add-button')
    );

    if (currentPaymentButton && nextPaymentButton) {
      syncAttributes(currentPaymentButton, nextPaymentButton);
      currentPaymentButton.style.removeProperty('display');
      currentPaymentButton.hidden = false;
    } else if (currentPaymentButton && !nextPaymentButton) {
      currentPaymentButton.hidden = true;
      currentPaymentButton.style.setProperty('display', 'none', 'important');
    }

    window.setTimeout(function() {
      currentWrapper.classList.remove('is-tuokus-payment-stabilized');
      currentWrapper.style.removeProperty('--tuokus-payment-stable-height');
    }, 700);

    return true;
  }

  function syncTrack(currentTrack, nextTrack) {
    var currentItems = null;
    var nextItems = null;
    var previousScrollLeft = 0;
    var previousDragSuppressUntil = '';

    if (!currentTrack || !nextTrack) {
      return false;
    }

    previousScrollLeft = currentTrack.scrollLeft;
    previousDragSuppressUntil = currentTrack.dataset.dragSuppressUntil || '';
    currentItems = Array.from(currentTrack.children);
    nextItems = Array.from(nextTrack.children);

    if (currentItems.length !== nextItems.length) {
      return false;
    }

    syncAttributes(currentTrack, nextTrack);

    currentItems.forEach(function(currentItem, index) {
      var nextItem = nextItems[index];

      syncAttributes(currentItem, nextItem);
      currentItem.innerHTML = nextItem.innerHTML;
    });

    if (previousDragSuppressUntil) {
      currentTrack.dataset.dragSuppressUntil = previousDragSuppressUntil;
    }

    currentTrack.scrollLeft = previousScrollLeft;

    return true;
  }

  function syncSelect(currentOption, nextOption) {
    var currentSelect = currentOption.querySelector('select.product-form__single-selector');
    var nextSelect = nextOption.querySelector('select.product-form__single-selector');

    if (!currentSelect || !nextSelect) {
      return false;
    }

    currentSelect.innerHTML = nextSelect.innerHTML;
    currentSelect.value = nextSelect.value;
    syncAttributes(currentSelect, nextSelect);

    return true;
  }

  function syncOptionRoot(currentOption, nextOption) {
    var currentLabel = currentOption.querySelector('.product-form__option-name');
    var nextLabel = nextOption.querySelector('.product-form__option-name');
    var currentTrack = currentOption.querySelector(TRACK_SELECTOR);
    var nextTrack = nextOption.querySelector(TRACK_SELECTOR);

    syncAttributes(currentOption, nextOption);

    if (currentLabel && nextLabel) {
      currentLabel.innerHTML = nextLabel.innerHTML;
      syncAttributes(currentLabel, nextLabel);
    }

    if (currentTrack || nextTrack) {
      return syncTrack(currentTrack, nextTrack);
    }

    return syncSelect(currentOption, nextOption);
  }

  function syncPricingPanel(currentBlock, nextBlock) {
    var currentPricingPanel = currentBlock
      ? currentBlock.querySelector('.product-form__pricing-panel')
      : null;
    var nextPricingPanel = nextBlock
      ? nextBlock.querySelector('.product-form__pricing-panel')
      : null;

    if (currentPricingPanel && nextPricingPanel) {
      currentPricingPanel.replaceWith(nextPricingPanel);
      return;
    }

    if (currentPricingPanel) {
      currentPricingPanel.remove();
      return;
    }

    if (nextPricingPanel && currentBlock) {
      currentBlock.appendChild(nextPricingPanel);
    }
  }

  tuokusTheme.preserveVariantSelector = function(currentBlock, nextBlock) {
    var currentPicker = currentBlock ? currentBlock.querySelector('variant-picker') : null;
    var nextPicker = nextBlock ? nextBlock.querySelector('variant-picker') : null;
    var currentOptions = null;
    var nextOptions = null;
    var currentVariantScript = null;
    var nextVariantScript = null;
    var currentVariantInput = null;
    var nextVariantInput = null;
    var synced = true;

    if (!currentPicker || !nextPicker) {
      return false;
    }

    currentOptions = Array.from(currentPicker.querySelectorAll('.product-form__option'));
    nextOptions = Array.from(nextPicker.querySelectorAll('.product-form__option'));

    if (currentOptions.length !== nextOptions.length) {
      return false;
    }

    currentOptions.forEach(function(currentOption, index) {
      if (!synced) {
        return;
      }

      synced = syncOptionRoot(currentOption, nextOptions[index]);
    });

    if (!synced) {
      return false;
    }

    currentVariantScript = currentPicker.querySelector('script[data-variant]');
    nextVariantScript = nextPicker.querySelector('script[data-variant]');

    if (currentVariantScript && nextVariantScript) {
      currentVariantScript.textContent = nextVariantScript.textContent;
    }

    currentVariantInput = currentPicker.querySelector('input[name="id"]');
    nextVariantInput = nextPicker.querySelector('input[name="id"]');

    if (currentVariantInput && nextVariantInput) {
      currentVariantInput.value = nextVariantInput.value;
      syncAttributes(currentVariantInput, nextVariantInput);
    }

    syncPricingPanel(currentBlock, nextBlock);
    syncAttributes(currentPicker, nextPicker);

    return true;
  };

  tuokusTheme.preserveBuyButtons = function(currentBlock, nextBlock) {
    return syncMobilePaymentState(currentBlock, nextBlock);
  };
})();

(function() {
  if (window.__TUOKUS_FINAL_RECOVERY_ACTIVE) {
    return;
  }

  function fallbackCopyText(text) {
    return new Promise(function(resolve, reject) {
      var textarea = document.createElement('textarea');

      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      textarea.style.pointerEvents = 'none';
      textarea.style.left = '-9999px';
      textarea.style.top = '0';
      document.body.appendChild(textarea);

      try {
        textarea.focus({ preventScroll: true });
      } catch (error) {
        textarea.focus();
      }

      textarea.select();
      textarea.setSelectionRange(0, textarea.value.length);

      try {
        if (document.execCommand('copy')) {
          resolve();
        } else {
          reject(new Error('copy failed'));
        }
      } catch (error) {
        reject(error);
      } finally {
        document.body.removeChild(textarea);
      }
    });
  }

  function copyText(text) {
    var value = String(text || '');

    if (!value) {
      return Promise.reject(new Error('empty text'));
    }

    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
      return navigator.clipboard.writeText(value).catch(function() {
        return fallbackCopyText(value);
      });
    }

    return fallbackCopyText(value);
  }

  function updateCouponButtonState(button, copied) {
    var label = button.querySelector('.product-form__coupon-copy-label');
    var defaultLabel = button.getAttribute('data-default-label') || 'Copy';
    var copiedLabel = button.getAttribute('data-copied-label') || 'Copied';

    if (!label) {
      return;
    }

    button.classList.toggle('is-copied', copied);
    label.textContent = copied ? copiedLabel : defaultLabel;
  }

  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-copy-coupon]');
    var couponCode = '';

    if (!button) {
      return;
    }

    couponCode = button.getAttribute('data-copy-value') || '';

    if (!couponCode) {
      return;
    }

    event.preventDefault();

    copyText(couponCode).then(function() {
      updateCouponButtonState(button, true);
      window.setTimeout(function() {
        updateCouponButtonState(button, false);
      }, 1800);
    }).catch(function() {
      updateCouponButtonState(button, false);
    });
  });
})();

(function() {
  var html = document.documentElement;
  var refreshTimer = null;
  var observer = null;
  var GROUP_SELECTOR = '.product-list, .product-list--scrollable, .collection-list, .activity-collection-grid, .activity-service-grid, .footer__block-list, .error-page__recovery-links, .product-gallery__thumbnail-list';
  var MOTION_DEFINITIONS = [
    {
      selector: '.shopify-section .section__header, .shopify-section .page__header, .shopify-section .collection__hero, .shopify-section .activity-hero__content, .shopify-section .error-page__hero, .shopify-section .error-page__search, .shopify-section .product-meta, .shopify-section .product-form__info-list, .shopify-section .product-service-guarantees',
      variant: 'hero'
    },
    {
      selector: '.shopify-section .product-gallery-card--sticky, .shopify-section .activity-lifestyle, .shopify-section .error-page__recovery, .shopify-section .footer__aside',
      variant: 'soft'
    },
    {
      selector: '.shopify-section .product-item, .shopify-section .collection-item, .shopify-section .activity-collection-card, .shopify-section .activity-service-card, .shopify-section .footer__block-item, .shopify-section .error-page__recovery-link, .shopify-section .product-gallery__thumbnail',
      variant: 'card'
    }
  ];
  var reducedMotionQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function isReducedMotion() {
    return Boolean(reducedMotionQuery && reducedMotionQuery.matches);
  }

  function syncReducedMotionState() {
    var isReduced = isReducedMotion();

    html.classList.toggle('motion-system-reduce', isReduced);

    if (isReduced && observer) {
      observer.disconnect();
      observer = null;
    }

    if (isReduced) {
      document.querySelectorAll('.motion-enter').forEach(function(element) {
        element.classList.add('is-in-view');
      });
    }
  }

  function ensureObserver() {
    if (observer || isReducedMotion() || !('IntersectionObserver' in window)) {
      return observer;
    }

    observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) {
          return;
        }

        entry.target.classList.add('is-in-view');
        observer.unobserve(entry.target);
      });
    }, {
      rootMargin: '0px 0px -12% 0px',
      threshold: 0.12
    });

    return observer;
  }

  function isInitiallyVisible(element) {
    var rect = element.getBoundingClientRect();

    return rect.bottom > 0 && rect.top < window.innerHeight * 0.92 && rect.right > 0 && rect.left < window.innerWidth;
  }

  function bindMotionElement(element, variant, groupCounts) {
    if (!element || element.dataset.motionBound === 'true') {
      return;
    }

    element.dataset.motionBound = 'true';
    element.classList.add('motion-enter', 'motion-enter--' + variant);

    var motionGroup = element.closest(GROUP_SELECTOR);
    var groupIndex = 0;

    if (motionGroup) {
      groupIndex = groupCounts.get(motionGroup) || 0;
      groupCounts.set(motionGroup, groupIndex + 1);
      element.style.setProperty('--motion-delay', Math.min(groupIndex * 56, 224) + 'ms');
    } else if (variant === 'hero') {
      element.style.setProperty('--motion-delay', '20ms');
    } else {
      element.style.setProperty('--motion-delay', '0ms');
    }

    if (isReducedMotion() || isInitiallyVisible(element)) {
      element.classList.add('is-in-view');
      return;
    }

    var motionObserver = ensureObserver();

    if (motionObserver) {
      motionObserver.observe(element);
    } else {
      element.classList.add('is-in-view');
    }
  }

  function scanMotionTargets(root) {
    if (!root || !root.querySelectorAll) {
      return;
    }

    var groupCounts = new WeakMap();

    MOTION_DEFINITIONS.forEach(function(definition) {
      root.querySelectorAll(definition.selector).forEach(function(element) {
        bindMotionElement(element, definition.variant, groupCounts);
      });
    });
  }

  function scheduleMotionRefresh(root) {
    window.clearTimeout(refreshTimer);

    refreshTimer = window.setTimeout(function() {
      syncReducedMotionState();
      scanMotionTargets(root && root.querySelectorAll ? root : document);
      html.classList.add('motion-system-enabled');
    }, 34);
  }

  function initMotionSystem() {
    syncReducedMotionState();
    scanMotionTargets(document);

    window.requestAnimationFrame(function() {
      html.classList.add('motion-system-enabled');
    });
  }

  if (reducedMotionQuery) {
    if (typeof reducedMotionQuery.addEventListener === 'function') {
      reducedMotionQuery.addEventListener('change', function() {
        scheduleMotionRefresh(document);
      });
    } else if (typeof reducedMotionQuery.addListener === 'function') {
      reducedMotionQuery.addListener(function() {
        scheduleMotionRefresh(document);
      });
    }
  }

  document.addEventListener('theme:loading:end', function() {
    scheduleMotionRefresh(document);
  });

  document.addEventListener('shopify:section:load', function(event) {
    scheduleMotionRefresh(event.target || document);
  });

  window.addEventListener('pageshow', function() {
    scheduleMotionRefresh(document);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMotionSystem);
  } else {
    initMotionSystem();
  }
})();

(function() {
  var mobileProductQuery = window.matchMedia ? window.matchMedia('(max-width: 999px)') : null;
  var scheduledFrame = null;

  function isMobileViewport() {
    return mobileProductQuery ? mobileProductQuery.matches : window.innerWidth <= 999;
  }

  function shouldSuppressStickyPurchase() {
    return Boolean(
      document.querySelector('.header__search-bar-wrapper.is-fixed') ||
      document.querySelector('.mini-cart[aria-hidden="false"]') ||
      document.querySelector('.drawer[aria-hidden="false"]')
    );
  }

  function ensurePurchaseSentinel(wrapper, paymentContainer) {
    if (!wrapper || !paymentContainer) {
      return null;
    }

    var sentinel = wrapper.querySelector('.product-form__mobile-purchase-sentinel');

    if (sentinel) {
      return sentinel;
    }

    sentinel = document.createElement('span');
    sentinel.className = 'product-form__mobile-purchase-sentinel';
    sentinel.setAttribute('aria-hidden', 'true');
    paymentContainer.parentNode.insertBefore(sentinel, paymentContainer);

    return sentinel;
  }

  function clearStickyPurchase(wrapper, paymentContainer) {
    if (!wrapper || !paymentContainer) {
      return;
    }

    wrapper.classList.remove('has-mobile-sticky-spacer');
    wrapper.style.removeProperty('--mobile-payment-height');
    paymentContainer.classList.remove('is-mobile-sticky');
  }

  function updateStickyPurchase(section) {
    if (!section || !section.querySelector) {
      return;
    }

    var wrapper = section.querySelector('.product-form__buy-buttons');
    var paymentContainer = wrapper ? wrapper.querySelector('.product-form__payment-container') : null;

    clearStickyPurchase(wrapper, paymentContainer);
    return;

    var sentinel = ensurePurchaseSentinel(wrapper, paymentContainer);

    if (!wrapper || !paymentContainer || !sentinel || !isMobileViewport() || shouldSuppressStickyPurchase()) {
      clearStickyPurchase(wrapper, paymentContainer);
      return;
    }

    var headerHeight = Math.ceil(document.querySelector('.header') ? document.querySelector('.header').getBoundingClientRect().height : 0);
    var sentinelRect = sentinel.getBoundingClientRect();
    var shouldStick = sentinelRect.bottom <= headerHeight + 10 && window.scrollY > headerHeight;

    if (!shouldStick) {
      clearStickyPurchase(wrapper, paymentContainer);
      return;
    }

    paymentContainer.classList.add('is-mobile-sticky');
    wrapper.classList.add('has-mobile-sticky-spacer');

    window.requestAnimationFrame(function() {
      wrapper.style.setProperty('--mobile-payment-height', Math.ceil(paymentContainer.getBoundingClientRect().height) + 'px');
    });
  }

  function refreshStickyPurchase() {
    document.querySelectorAll('[data-section-type="product"]').forEach(updateStickyPurchase);
  }

  function scheduleStickyPurchaseRefresh() {
    if (scheduledFrame) {
      window.cancelAnimationFrame(scheduledFrame);
    }

    scheduledFrame = window.requestAnimationFrame(function() {
      scheduledFrame = null;
      refreshStickyPurchase();
    });
  }

  if (mobileProductQuery) {
    if (typeof mobileProductQuery.addEventListener === 'function') {
      mobileProductQuery.addEventListener('change', scheduleStickyPurchaseRefresh);
    } else if (typeof mobileProductQuery.addListener === 'function') {
      mobileProductQuery.addListener(scheduleStickyPurchaseRefresh);
    }
  }

  document.addEventListener('variant:changed', scheduleStickyPurchaseRefresh);
  document.addEventListener('theme:loading:end', scheduleStickyPurchaseRefresh);
  document.addEventListener('shopify:section:load', scheduleStickyPurchaseRefresh);
  window.addEventListener('pageshow', scheduleStickyPurchaseRefresh);
  window.addEventListener('resize', scheduleStickyPurchaseRefresh);
  window.addEventListener('scroll', scheduleStickyPurchaseRefresh, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleStickyPurchaseRefresh);
  } else {
    scheduleStickyPurchaseRefresh();
  }
})();

(function() {
  var availabilityCache = Object.create(null);
  var pendingAvailabilityRequests = Object.create(null);
  var refreshTimer = null;
  var observer = null;
  var ITEM_SELECTOR = [
    '.activity-recommended-products-section .product-item',
    '[data-section-type="featured-collection"] .product-item',
    '.product-recommendations .product-item',
    '.search-bar__result-products .search-bar__result-item'
  ].join(', ');
  var SURFACE_SELECTOR = [
    '.activity-recommended-products-section',
    '[data-section-type="featured-collection"]',
    '[data-section-type="product-recommendations"]',
    '.search-bar__result-products'
  ].join(', ');

  function extractProductHandle(url) {
    var pathname = url || '';
    var matches = null;

    if (!pathname) {
      return null;
    }

    try {
      pathname = new URL(pathname, window.location.origin).pathname;
    } catch (error) {
      pathname = pathname.split('?')[0];
    }

    matches = pathname.match(/\/products\/([^/?#]+)/);

    return matches ? matches[1] : null;
  }

  function getAvailabilityUrl(handle) {
    return '/products/' + handle + '.js';
  }

  function fetchProductAvailability(handle) {
    if (!handle) {
      return Promise.resolve(true);
    }

    if (Object.prototype.hasOwnProperty.call(availabilityCache, handle)) {
      return Promise.resolve(availabilityCache[handle]);
    }

    if (pendingAvailabilityRequests[handle]) {
      return pendingAvailabilityRequests[handle];
    }

    pendingAvailabilityRequests[handle] = window.fetch(getAvailabilityUrl(handle), {
      credentials: 'same-origin'
    }).then(function(response) {
      if (!response.ok) {
        throw new Error('Failed to load product availability for ' + handle);
      }

      return response.json();
    }).then(function(productData) {
      availabilityCache[handle] = Boolean(productData && productData.available);

      return availabilityCache[handle];
    }).catch(function() {
      availabilityCache[handle] = true;

      return true;
    }).finally(function() {
      delete pendingAvailabilityRequests[handle];
    });

    return pendingAvailabilityRequests[handle];
  }

  function getItemLink(item) {
    if (!item) {
      return null;
    }

    if (item.matches('.search-bar__result-item')) {
      return item;
    }

    return item.querySelector('a[href*="/products/"]');
  }

  function getAvailabilityHint(item) {
    var link = getItemLink(item);
    var selectedVariantAvailability = null;

    if (!link || !link.getAttribute) {
      return null;
    }

    selectedVariantAvailability = link.getAttribute('data-selected-variant-available');

    if (selectedVariantAvailability === 'true') {
      return true;
    }

    if (selectedVariantAvailability === 'false') {
      return false;
    }

    return null;
  }

  function getCleanupSurface(item) {
    if (!item || !item.closest) {
      return null;
    }

    return item.closest(SURFACE_SELECTOR);
  }

  function cleanupSearchResultSurface(surface) {
    if (!surface || !surface.matches('.search-bar__result-products')) {
      return;
    }

    if (surface.querySelector('.search-bar__result-item')) {
      return;
    }

    if (surface.previousElementSibling && surface.previousElementSibling.classList.contains('search-bar__result-category')) {
      surface.previousElementSibling.remove();
    }

    surface.remove();
  }

  function cleanupProductSurface(surface) {
    if (!surface || surface.matches('.search-bar__result-products')) {
      cleanupSearchResultSurface(surface);
      return;
    }

    if (surface.querySelector('.product-item')) {
      return;
    }

    surface.style.display = 'none';
  }

  function cleanupSurface(surface) {
    if (!surface) {
      return;
    }

    if (surface.matches('.search-bar__result-products')) {
      cleanupSearchResultSurface(surface);
      return;
    }

    cleanupProductSurface(surface);
  }

  function auditSellableMerchandising(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var items = Array.from(scope.querySelectorAll(ITEM_SELECTOR)).filter(function(item) {
      return item.dataset.sellableAudit !== 'done';
    });

    if (!items.length) {
      return;
    }

    items.forEach(function(item) {
      item.dataset.sellableAudit = 'done';
    });

    Promise.allSettled(items.map(function(item) {
      var link = getItemLink(item);
      var handle = extractProductHandle(link ? link.getAttribute('href') : '');
      var availabilityHint = getAvailabilityHint(item);

      if (availabilityHint === false) {
        var hintedSurface = getCleanupSurface(item);
        item.remove();
        cleanupSurface(hintedSurface);

        return Promise.resolve();
      }

      if (availabilityHint === true || !handle) {
        return Promise.resolve();
      }

      return fetchProductAvailability(handle).then(function(isAvailable) {
        var surface = null;

        if (isAvailable || !item.isConnected) {
          return;
        }

        surface = getCleanupSurface(item);
        item.remove();
        cleanupSurface(surface);
      });
    })).then(function() {
      document.querySelectorAll(SURFACE_SELECTOR).forEach(cleanupSurface);
    });
  }

  function scheduleSellableAudit(root) {
    window.clearTimeout(refreshTimer);

    refreshTimer = window.setTimeout(function() {
      auditSellableMerchandising(root);
    }, 80);
  }

  function initSellableAuditObserver() {
    if (observer || !document.body || !window.MutationObserver) {
      return;
    }

    observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        Array.from(mutation.addedNodes).forEach(function(node) {
          if (!node || node.nodeType !== 1) {
            return;
          }

          if ((node.matches && (node.matches(ITEM_SELECTOR) || node.matches(SURFACE_SELECTOR))) || (node.querySelector && node.querySelector(ITEM_SELECTOR))) {
            scheduleSellableAudit(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('theme:loading:end', function() {
    scheduleSellableAudit(document);
  });

  document.addEventListener('shopify:section:load', function(event) {
    scheduleSellableAudit(event.target || document);
  });

  window.addEventListener('pageshow', function() {
    scheduleSellableAudit(document);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initSellableAuditObserver();
      scheduleSellableAudit(document);
    });
  } else {
    initSellableAuditObserver();
    scheduleSellableAudit(document);
  }
})();

(function() {
  if (window.__TUOKUS_FINAL_RECOVERY_ACTIVE) {
    return;
  }

  var PRODUCT_SECTION_SELECTOR = '[data-section-type="product"]';
  var SUPPORT_TITLES = ['\u30b5\u30a4\u30ba\u306b\u3064\u3044\u3066', '\u304a\u624b\u5165\u308c\u65b9\u6cd5', '\u914d\u9001\u30fb\u8fd4\u54c1\u306b\u3064\u3044\u3066'];
  var REFUND_MARKUP = [
    '<h2>\u914d\u9001\u30fb\u8fd4\u54c1\u30dd\u30ea\u30b7\u30fc\u306b\u3064\u3044\u3066</h2>',
    '<p>\u65e5\u672c\u3078\u306e\u304a\u5c4a\u3051\u76ee\u5b89\u306f\u901a\u5e388\u301c11\u65e5\u3067\u3059\u3002\u5730\u57df\u3084\u914d\u9001\u72b6\u6cc1\u306b\u3088\u308a\u524d\u5f8c\u3059\u308b\u5834\u5408\u304c\u3042\u308a\u307e\u3059\u306e\u3067\u3001\u3042\u3089\u304b\u3058\u3081\u3054\u4e86\u627f\u304f\u3060\u3055\u3044\u3002</p>',
    '<h3>\u8fd4\u54c1\u306b\u3064\u3044\u3066</h3>',
    '<p>\u5546\u54c1\u306b\u4e0d\u5177\u5408\u3084\u7834\u640d\u304c\u3042\u3063\u305f\u5834\u5408\u306f\u3001\u5546\u54c1\u5230\u7740\u5f8c\u3067\u304d\u308b\u3060\u3051\u65e9\u304f\u3054\u9023\u7d61\u304f\u3060\u3055\u3044\u3002\u5185\u5bb9\u3092\u78ba\u8a8d\u306e\u3046\u3048\u3001\u4ea4\u63db\u307e\u305f\u306f\u8fd4\u54c1\u306e\u6d41\u308c\u3092\u3054\u6848\u5185\u3044\u305f\u3057\u307e\u3059\u3002</p>',
    '<h3>\u3054\u78ba\u8a8d\u4e8b\u9805</h3>',
    '<p>\u3054\u4f7f\u7528\u5f8c\u306e\u6c5a\u308c\u3084\u304a\u5ba2\u69d8\u90fd\u5408\u3067\u306e\u8fd4\u54c1\u6761\u4ef6\u306a\u3069\u3001\u8a73\u3057\u304f\u306f\u30b9\u30c8\u30a2\u306e\u914d\u9001\u30fb\u8fd4\u54c1\u30dd\u30ea\u30b7\u30fc\u3092\u3054\u78ba\u8a8d\u304f\u3060\u3055\u3044\u3002</p>'
  ].join('');
  var MOJIBAKE_PATTERN = /閸熷棗鎼閵夘兙鍎瀨闁板秹|鏉╂柨鎼閵堢偣鍋唡[\uFFFD]/;
  function syncVisibleGallery(sectionRoot) {
    var gallery = sectionRoot && sectionRoot.querySelector ? sectionRoot.querySelector('.product-gallery') : null;
    var visibleCarouselItems = [];
    var visibleThumbnails = [];
    var activeCarouselItem = null;
    var activeThumbnail = null;
    var activeMediaId = '';
    var visibleCount = 0;
    var carousel = null;

    if (!gallery) {
      return;
    }

    visibleCarouselItems = Array.prototype.slice.call(
      sectionRoot.querySelectorAll('.product-gallery__carousel-item:not(.is-filtered)')
    );
    visibleThumbnails = Array.prototype.slice.call(
      sectionRoot.querySelectorAll('.product-gallery__thumbnail:not(.is-filtered)')
    );
    activeCarouselItem =
      sectionRoot.querySelector('.product-gallery__carousel-item.is-selected:not(.is-filtered)') ||
      visibleCarouselItems[0] ||
      null;

    sectionRoot.querySelectorAll('.product-gallery__carousel-item.is-selected').forEach(function(item) {
      item.classList.remove('is-selected');
    });

    if (activeCarouselItem) {
      activeCarouselItem.classList.add('is-selected');
      activeMediaId = activeCarouselItem.getAttribute('data-media-id') || '';
    }

    sectionRoot.querySelectorAll('.product-gallery__thumbnail.is-nav-selected').forEach(function(item) {
      item.classList.remove('is-nav-selected');
    });

    activeThumbnail = activeMediaId
      ? sectionRoot.querySelector('.product-gallery__thumbnail[data-media-id="' + activeMediaId + '"]:not(.is-filtered)')
      : (visibleThumbnails[0] || null);

    if (activeThumbnail) {
      activeThumbnail.classList.add('is-nav-selected');
    }

    visibleCount = visibleThumbnails.length || visibleCarouselItems.length;
    gallery.classList.toggle('product-gallery--single-visible-media', visibleCount <= 1);
    gallery.classList.toggle('product-gallery--few-visible-media', visibleCount > 1 && visibleCount <= 2);
    gallery.setAttribute('data-visible-media-count', String(visibleCount));

    if (activeMediaId) {
      carousel = sectionRoot.querySelector('.product-gallery__carousel');

      if (carousel) {
        carousel.setAttribute('data-initial-media-id', activeMediaId);
      }
    }
  }

  function reconcileSection(sectionRoot) {
    if (!sectionRoot || !sectionRoot.querySelectorAll) {
      return;
    }

    sectionRoot.querySelectorAll('.product-block-list__item--content .card__title').forEach(function(title, index) {
      if (index < SUPPORT_TITLES.length) {
        title.textContent = SUPPORT_TITLES[index];
      }
    });

    sectionRoot.querySelectorAll('.product-block-list__item--description .card__title').forEach(function(title) {
      title.textContent = '\u5546\u54c1\u8a73\u7d30';
    });

    sectionRoot.querySelectorAll('.product-block-list__item--reviews .card__title').forEach(function(title) {
      title.textContent = '\u30ec\u30d3\u30e5\u30fc';
    });

    sectionRoot.querySelectorAll('#modal-refunds-policy .rte').forEach(function(content) {
      var text = (content.textContent || '').trim();

      if (!text || MOJIBAKE_PATTERN.test(text)) {
        content.innerHTML = REFUND_MARKUP;
      }
    });

    syncVisibleGallery(sectionRoot);
  }

  function reconcileAll(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll(PRODUCT_SECTION_SELECTOR).forEach(function(sectionRoot) {
      reconcileSection(sectionRoot);
    });
  }

  document.addEventListener('theme:loading:end', function(event) {
    window.requestAnimationFrame(function() {
      reconcileAll(event.target || document);
    });
  });

  document.addEventListener('shopify:section:load', function(event) {
    window.requestAnimationFrame(function() {
      reconcileAll(event.target || document);
    });
  });

  document.addEventListener('change', function(event) {
    var optionInput = event.target.closest && event.target.closest('.product-form__single-selector[data-option-position]');
    var sectionRoot = optionInput ? optionInput.closest(PRODUCT_SECTION_SELECTOR) : null;

    if (!sectionRoot) {
      return;
    }

    window.setTimeout(function() {
      reconcileSection(sectionRoot);
    }, 48);
  }, true);

  window.addEventListener('pageshow', function() {
    window.requestAnimationFrame(function() {
      reconcileAll(document);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      reconcileAll(document);
    });
  } else {
    reconcileAll(document);
  }
})();

(function() {
  if (window.__TUOKUS_FINAL_RECOVERY_ACTIVE) {
    return;
  }

  var PRODUCT_SECTION_SELECTOR = '[data-section-type="product"]';
  var COPY_BUTTON_SELECTOR = '[data-copy-coupon], [data-coupon-copy-button]';

  function toArray(nodes) {
    return Array.prototype.slice.call(nodes || []);
  }

  function legacyCopyText(value) {
    return new Promise(function(resolve, reject) {
      var textarea = document.createElement('textarea');
      var copied = false;

      textarea.value = String(value || '');
      textarea.setAttribute('readonly', 'readonly');
      textarea.style.position = 'fixed';
      textarea.style.top = '-9999px';
      textarea.style.left = '-9999px';
      textarea.style.opacity = '0';

      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      textarea.setSelectionRange(0, textarea.value.length);

      try {
        copied = document.execCommand('copy');
      } catch (error) {
        copied = false;
      }

      document.body.removeChild(textarea);

      if (copied) {
        resolve();
      } else {
        reject(new Error('copy failed'));
      }
    });
  }

  function writeCouponText(value) {
    var text = String(value || '').trim();

    if (!text) {
      return Promise.reject(new Error('empty coupon'));
    }

    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function' && window.isSecureContext) {
      return navigator.clipboard.writeText(text).catch(function() {
        return legacyCopyText(text);
      });
    }

    return legacyCopyText(text);
  }

  function updateCouponButtonLabel(button, copied) {
    var label = button.querySelector('.product-form__coupon-copy-label');
    var defaultLabel = button.getAttribute('data-default-label') || 'コピー';
    var copiedLabel = button.getAttribute('data-copied-label') || 'コピー済み';

    button.classList.toggle('is-copied', copied);

    if (label) {
      label.textContent = copied ? copiedLabel : defaultLabel;
      return;
    }

    button.textContent = copied ? copiedLabel : defaultLabel;
  }

  function extractCouponCode(button) {
    var root = null;
    var codeNode = null;

    if (!button) {
      return '';
    }

    root = button.closest('[data-coupon-copy-root], .product-form__pricing-panel, .product-coupon-box');
    codeNode = root ? root.querySelector('[data-coupon-code], .product-form__coupon-code, .product-coupon-box__code') : null;

    return (
      button.getAttribute('data-copy-value') ||
      button.getAttribute('data-coupon-code') ||
      button.getAttribute('data-copy-text') ||
      (codeNode ? (codeNode.getAttribute('data-coupon-code') || codeNode.textContent || '') : '') ||
      ''
    ).trim();
  }

  function handleCouponCopy(event) {
    var button = event.target && event.target.closest ? event.target.closest(COPY_BUTTON_SELECTOR) : null;
    var couponCode = '';

    if (!button) {
      return;
    }

    couponCode = extractCouponCode(button);

    if (!couponCode) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    writeCouponText(couponCode).then(function() {
      updateCouponButtonLabel(button, true);

      window.setTimeout(function() {
        updateCouponButtonLabel(button, false);
      }, 1800);
    }).catch(function() {
      updateCouponButtonLabel(button, false);
    });
  }

  function getVisibleCarouselItems(sectionRoot) {
    return toArray(sectionRoot.querySelectorAll('.product-gallery__carousel-item')).filter(function(item) {
      return !item.classList.contains('is-filtered');
    });
  }

  function getVisibleThumbnails(sectionRoot) {
    return toArray(sectionRoot.querySelectorAll('.product-gallery__thumbnail')).filter(function(item) {
      return !item.classList.contains('is-filtered');
    });
  }

  function revealSharedDetailItems(sectionRoot) {
    toArray(sectionRoot.querySelectorAll('.product-gallery__carousel-item[data-tuokus-shared-detail="true"]')).forEach(function(item) {
      item.classList.remove('is-filtered');
      item.removeAttribute('aria-hidden');
    });

    toArray(sectionRoot.querySelectorAll('.product-gallery__thumbnail[data-tuokus-shared-detail="true"]')).forEach(function(item) {
      item.classList.remove('is-filtered');
      item.removeAttribute('aria-hidden');
    });
  }

  function unfilterMatchingThumbnail(sectionRoot, mediaId) {
    var thumbnail = null;

    if (!mediaId) {
      return;
    }

    thumbnail = sectionRoot.querySelector('.product-gallery__thumbnail[data-media-id="' + mediaId + '"]');

    if (thumbnail) {
      thumbnail.classList.remove('is-filtered');
      thumbnail.removeAttribute('aria-hidden');
    }
  }

  function ensureGalleryContinuity(sectionRoot) {
    var gallery = null;
    var carousel = null;
    var carouselItems = [];
    var thumbnails = [];
    var visibleCarouselItems = [];
    var visibleThumbnails = [];
    var activeCarouselItem = null;
    var activeThumbnail = null;
    var activeMediaId = '';
    var visibleCount = 0;

    if (!sectionRoot || !sectionRoot.querySelectorAll) {
      return;
    }

    gallery = sectionRoot.querySelector('.product-gallery');
    carousel = sectionRoot.querySelector('.product-gallery__carousel');
    carouselItems = toArray(sectionRoot.querySelectorAll('.product-gallery__carousel-item'));
    thumbnails = toArray(sectionRoot.querySelectorAll('.product-gallery__thumbnail'));

    if (!gallery || !carouselItems.length) {
      return;
    }

    visibleCarouselItems = getVisibleCarouselItems(sectionRoot);

    if (visibleCarouselItems.length <= 1 && sectionRoot.querySelector('.product-gallery__carousel-item[data-tuokus-shared-detail="true"]')) {
      revealSharedDetailItems(sectionRoot);
      visibleCarouselItems = getVisibleCarouselItems(sectionRoot);
    }

    if (!visibleCarouselItems.length) {
      carouselItems[0].classList.remove('is-filtered');
      carouselItems[0].removeAttribute('aria-hidden');
      unfilterMatchingThumbnail(sectionRoot, carouselItems[0].getAttribute('data-media-id') || '');
      visibleCarouselItems = getVisibleCarouselItems(sectionRoot);
    }

    activeCarouselItem =
      sectionRoot.querySelector('.product-gallery__carousel-item.is-selected:not(.is-filtered)') ||
      visibleCarouselItems[0] ||
      carouselItems[0] ||
      null;

    if (activeCarouselItem) {
      activeCarouselItem.classList.remove('is-filtered');
      if (!activeCarouselItem.classList.contains('is-selected')) {
        activeCarouselItem.classList.add('is-selected');
      }
      activeMediaId = activeCarouselItem.getAttribute('data-media-id') || '';
      unfilterMatchingThumbnail(sectionRoot, activeMediaId);
    }

    carouselItems.forEach(function(item) {
      if (item !== activeCarouselItem) {
        item.classList.remove('is-selected');
      }
    });

    visibleThumbnails = getVisibleThumbnails(sectionRoot);
    activeThumbnail = activeMediaId
      ? sectionRoot.querySelector('.product-gallery__thumbnail[data-media-id="' + activeMediaId + '"]:not(.is-filtered)')
      : (visibleThumbnails[0] || null);

    if (activeThumbnail) {
      if (!activeThumbnail.classList.contains('is-nav-selected')) {
        activeThumbnail.classList.add('is-nav-selected');
      }
    }

    thumbnails.forEach(function(item) {
      if (item !== activeThumbnail) {
        item.classList.remove('is-nav-selected');
      }
    });

    visibleCount = Math.max(getVisibleCarouselItems(sectionRoot).length, getVisibleThumbnails(sectionRoot).length);
    gallery.classList.toggle('product-gallery--single-visible-media', visibleCount <= 1);
    gallery.classList.toggle('product-gallery--few-visible-media', visibleCount > 1 && visibleCount <= 2);
    gallery.setAttribute('data-visible-media-count', String(visibleCount));

    if (carousel && activeMediaId) {
      carousel.setAttribute('data-initial-media-id', activeMediaId);
    }
  }

  function scheduleGalleryContinuity(sectionRoot, delay) {
    if (!sectionRoot) {
      return;
    }

    window.setTimeout(function() {
      ensureGalleryContinuity(sectionRoot);
    }, delay || 80);
  }

  function reconcileProductSections(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll(PRODUCT_SECTION_SELECTOR).forEach(function(sectionRoot) {
      ensureGalleryContinuity(sectionRoot);
    });
  }

  document.addEventListener('click', handleCouponCopy, true);

  document.addEventListener('click', function(event) {
    var trigger = event.target && event.target.closest
      ? event.target.closest('.variant-swatch, .block-swatch, .color-swatch, .product-form__option-value')
      : null;
    var sectionRoot = trigger && trigger.closest ? trigger.closest(PRODUCT_SECTION_SELECTOR) : null;

    if (!sectionRoot) {
      return;
    }

    scheduleGalleryContinuity(sectionRoot, 90);
    scheduleGalleryContinuity(sectionRoot, 220);
  }, true);

  document.addEventListener('change', function(event) {
    var trigger = event.target && event.target.closest
      ? event.target.closest('.product-form__single-selector[data-option-position], .product-form__option input, .product-form__option select')
      : null;
    var sectionRoot = trigger && trigger.closest ? trigger.closest(PRODUCT_SECTION_SELECTOR) : null;

    if (!sectionRoot) {
      return;
    }

    scheduleGalleryContinuity(sectionRoot, 70);
    scheduleGalleryContinuity(sectionRoot, 180);
  }, true);

  document.addEventListener('variant:changed', function(event) {
    var sectionRoot = event.target && event.target.closest ? event.target.closest(PRODUCT_SECTION_SELECTOR) : null;

    if (!sectionRoot && event.detail && event.detail.sectionId) {
      sectionRoot = document.querySelector(PRODUCT_SECTION_SELECTOR + '[data-section-id="' + event.detail.sectionId + '"]');
    }

    scheduleGalleryContinuity(sectionRoot, 70);
    scheduleGalleryContinuity(sectionRoot, 190);
  }, true);

  document.addEventListener('theme:loading:end', function(event) {
    window.requestAnimationFrame(function() {
      reconcileProductSections(event.target || document);
    });
  });

  document.addEventListener('shopify:section:load', function(event) {
    window.requestAnimationFrame(function() {
      reconcileProductSections(event.target || document);
    });
  });

  window.addEventListener('pageshow', function() {
    window.requestAnimationFrame(function() {
      reconcileProductSections(document);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      reconcileProductSections(document);
    });
  } else {
    reconcileProductSections(document);
  }
})();
